import React from 'react'
import "react-datepicker/dist/react-datepicker.css";
import { useState, useEffect,useRef, useMemo} from 'react';
import './classes/EditProfile.css';
import DatePicker from "react-datepicker";
import Select from 'react-select';
import { configData } from "../config";
import Loading from './Loading';
import SweetAlert2 from 'react-sweetalert2';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { format } from "date-fns";
import Editor from 'react-simple-wysiwyg';
import TimeInput from './TimeInput';
import { useTimezoneSelect, allTimezones } from "react-timezone-select";

const labelStyle = "original"
const timezones = {
  ...allTimezones,
  "Europe/Berlin": "Frankfurt",
  'America/Lima': 'Pittsburgh',
}

const AdminEditProfile = ({uid,userLoggedInRoles,userRoles,picture,userAgentAssets,userScoutAssets,userAthleteAssets, userAmbassadorAssets, userLeadAssets, userMentorAssets,userEventAssets}) => {
    const navigate = useNavigate();

    // const { options, parseTimezone } = useTimezoneSelect({ labelStyle, timezones });
    // const { options: baseOptions, parseTimezone } = useTimezoneSelect({ labelStyle, timezones });

    const mentorSportsList = [
        {value:"cricket", label:"Cricket"},
        {value:"baseball", label:"Baseball"},
        {value:"basketball", label:"Basketball"},
        {value:"football", label:"Football"},
        {value:"hockey", label:"Hockey"},
        {value:"rugby", label:"Rugby"},
        {value:"soccer", label:"Soccer"}
    ];

    const agentCertificateList = [
        'CFL Certified',
        'DEL Certified',
        'FIBA Certified',
        'FIFA Certified',
        'MLB Certified',
        'NBA Certified',
        'NFLPA Certified',
        'NHL Certified',
        'NIL Certified',
        'PHPA Certified',
        'WNBA Certified'
    ];

    const months = [
        { value: "01", label: "Jan" },
        { value: "02", label: "Feb" },
        { value: "03", label: "Mar" },
        { value: "04", label: "Apr" },
        { value: "05", label: "May" },
        { value: "06", label: "Jun" },
        { value: "07", label: "Jul" },
        { value: "08", label: "Aug" },
        { value: "09", label: "Sep" },
        { value: "10", label: "Oct" },
        { value: "11", label: "Nov" },
        { value: "12", label: "Dec" }
    ];

    const days = Array.from({ length: 31 }, (_, i) => {
        const day = String(i + 1).padStart(2, "0");
        return { value: day, label: day };
    });

    const currentYear = new Date().getFullYear();
    const maxYear = currentYear + 10; 
    const minYear = currentYear - 10;
    const agentExpirationYears = Array.from(
        { length: maxYear - minYear + 1 },
        (_, i) => {
            const year = String(minYear + i);
            return { value: year, label: year };
        }
    );

    const years = Array.from(
    { length: 7 },
    (_, i) => {
        const year = String(currentYear - 3 + i);
        return { value: year, label: year };
    }
    );

    // const hours = Array.from(
    //     { length: 23 - 0 + 1 },
    //     (_, i) => {
    //     const hour = String(0 + i);
    //     return { value: hour, label: hour };
    //     }
    // );
    const hours = Array.from(
        { length: 24 },
        (_, i) => {
            const hour = String(i).padStart(2, '0'); 
            return { value: hour, label: hour };
        }
    );

    const clock = [
        '00',
        '15',
        '30',
        '45'
    ];

    const schoolYears = Array.from(
        { length: currentYear - 1960 + 1 },
        (_, i) => {
        const schoolYear = String(currentYear - i);
        return { value: schoolYear, label: schoolYear };
        }
    );

    const [formData, setFormData] = useState({
        field_user_assignment:'',
        firstName:'',
        lastName:'',
        field_meta_title:'',
        field_meta_keywords:'',
        field_meta_description:'',
        field_biography:'',
        field_education:'',
        field_career_information:'',
        field_sports_background:'',
        field_professional_background:'',
        field_volunteer_work:'',
        field_mission_statement:'',
        field_show_on_frontend_agent: 0,
        field_agent_sort_order: '',
        field_agent_id: '',
        field_agent_title: '',
        field_agent_biography:'',
        field_delete_agent_photo:0,
        field_agent_photo:'',
        field_agent_contract:[],
        field_agent_sports:[],
        field_agent_certifications: [],
        field_special_certifications:[],
        field_agent_region:'',
        field_scout_rank:'',
        field_expiration_date: '',
        field_show_on_frontend_scout:0,
        field_scout_sort_order:'',
        field_scoutid:'',
        field_scout_title:'',
        field_scout_biography:'',
        field_delete_scout_photo:0,
        field_scout_photo:'',
        field_scout_contract:[],
        field_scout_sport:[],
        field_scout_region: '',
        field_scout_featured:0,
        field_mentor_sort_order:'',
        field_mentor_title:'',
        field_athlete_contract:[],
        field_mentor_biography:'',
        field_mentor_sports:[],
        field_mentor_region: '',
        field_first_name_badge:'',
        field_delete_mentor_photo:0,
        field_mentor_photo:'',
        field_last_name_badge:'',
        field_name_school_badge:'',
        field_name_title_badge:'',
        field_name_org_badge:'',
        field_lead_type:[],
        field_call_back_month:'',
        field_call_back_day:'',
        field_call_back_year:'',
        field_call_back_hour:'',
        field_call_back_minute:'',
        field_call_back_second:'',
        field_lead_sort_flag:'',
        field_lead_priority:'Medium',
        field_street: '',
        field_smww_email:'',
        field_street_2: '',
        field_realemail:'',
        field_city: '',
        field_state: '',
        field_postal_code: '',
        field_country: '',
        // continent:'Asia',
        field_continentid:'',
        field_linkedin_url: '',
        field_appid:'',
        field_phone: '',
        field_secondary_phone: '',
        field_province_region: '',
        field_other_referrer:'',
        field_age:'',
        field_education_state:'',
        field_education_city:'',
        field_school:'',
        field_last_attended:'',
        field_add_to_divvy_draft:'',
        field_sports_recom: '',
        field_referrer: '',
        field_team_refer: '',
        field_gender: '',
        field_highest_grade: '',
        field_college: '',
        field_degree: '',
        field_current_job: '',
        field_major: '',
        field_military: '',
        field_military_id: '',
        field_been_convicted: '',
        field_felony: '',
        field_is_for_credit: '',
        field_team_organization: '',
        field_night_phone:'',
        field_fax:'',
        field_pager:'',
        field_athelte_id:'',
        field_amount_paid:'',
        field_contact_id:'',
        field_event_id:'',
        field_coupon_code:'',
        field_contact_notes:'',
        field_nationality:'',
        appRegister_step:'',
        field_cuc_degrees: [],
        field_agent_slug:'',
        field_scout_slug:'',
        field_ip_address:'',
        field_doc_talk:[],
        field_favteam: '',
        field_elaborate: '',
        field_date_of_app:'',
        field_date_of_acceptance:'',
        applied_courses:[],
        field_app_status:'2',
        field_sales_call_made:0,
        field_app_is_agent:0,
        field_app_is_scout:0,
        field_over18:0,
        field_dormant:0,
        field_srm400:0,
        field_am400:0,
        field_gi_bill:0,
        field_gi_bill_status: '_none',
        field_new_apply: 0,
        field_show_on_frontend_athlete:0,
        field_current_class:0,
        field_athlete_featured:0,
        field_available:0,
        field_show_on_smww_basketball:0,
        field_date_of_signing: {
            date: '',
            time: ''
        },
        // field_agent_expiration_date: {
        //     year:"",
        //     month:"",
        //     day:""
        // },
        field_agent_expiration_year:'',
        field_agent_expiration_month:'',
        field_agent_expiration_date:'',
        field_agent_featured:0,
        field_last_date_accept:'',
        field_signing_agent_id:'',
        field_current_agent_id:'',
        field_date_of_assignment: {
            date: '',
            time: ''
        },
        field_athlete_sports:[],
        field_athlete_position:'',
            field_dob: {
            date: '',
            time: ''
        },
        field_athlete_rank:'',
        field_tier_status:'',
        field_tier_status_date: {
            date: '',
            time: ''
        },
        field_athlete_type:'',
        field_high_school: '',
        field_hs_location: '',
        field_hs_grad_year: '',
        field_college_grad_date: '',
        field_birthday: '',
        field_reg_step: '3',
        field_hear_about_doc_talk: '',
        field_athlete_height:'',
        field_height_unit:'',
        field_athlete_weight:'',
        field_weight_unit:'',
        field_university: '',
        field_instagram_url:'',
        field_instagram_handle:'',
        field_instagram_followers:'',
        field_facebook_url:'',
        field_facebook_handle:'',
        field_facebook_followers:'',
        field_twitter_url:'',
        field_twitter_followers:'',
        field_user_youtube_url:'',
        field_youtube_subscribers:'', 
        field_linkedin_handle:'',
        field_linkedin_followers:'',
        field_tiktok_url:'',
        field_tiktok_followers:'',
        field_cuc_application:'',
        field_talk_with_dr_lashbrook:'',
        field_advanced_certificates_ques:'',
        field_request_more_info:'',
        field_most_recent_college:'',
        field_most_recent_seasons_stats:'',
        field_first_form_submission:'',
        field_last_form_submitted:'',
        field_agents_represented_by: [],
        field_sports_you_worked: [],
        field_other_sports_you_worked:'',
        field_your_dream_job:[],
        field_other_dream_job:'',
        field_job_resume:'',
        field_how_to_contact_client:'',
        field_q_a:'',
        sort_flags:[],
        field_sports_focus: [],
        field_show_on_frontend_ambassado:0,
        userName:'',
        status:'1',
        roles:['2'],
        current_pass: '',
        mail: '',
        password: '',
        confirmPassword: '',
        field_ambassador_slug:'',
        picture: null,
        pictureDelete: false,
        // timezone: '',
        field_recent_graduation_date:null,
        field_graduated_courses:'',
        field_video_highlights:'',
        field_google_click_id:'',
        field_text_me_with_news_offers:0,
        uid:uid,    
        revision:'',
        button_name:'Save',
        cancel_button:'Cancel account',
        placements: [{ page: '', order: '1' }],
    });
    const[error,setError] = useState({});
    const [fieldErrors, setFieldErrors] = useState({
        userName: false
    });
    const [editorMode, setEditorMode] = useState({
        biography: true,
        education: true,
        qa: true,
        contact: true,
        careerinfo:true,
        agentBio:true,
        scoutBio:true,
        mentorbio:true,
        most_recent_seasons_stats:true,
        video_highlights:true,
    });
   
    const toggleEditor = (field) => {
        const fieldMap = {
            biography: 'field_biography',
            education: 'field_education',
            qa: 'field_q_a',
            contact: 'field_how_to_contact_client',
            careerinfo:'field_career_information',
            agentBio: 'field_agent_biography',
            scoutBio:'field_scout_biography',
            mentorbio:'field_mentor_biography',
            most_recent_seasons_stats:'field_most_recent_seasons_stats',
            video_highlights:'field_video_highlights',
        };
    
        const fieldKey = fieldMap[field];
    
        setEditorMode(prev => {
            const switchingToRich = !prev[field];
        
            setFormData(prevFormData => {
            const value = prevFormData[fieldKey] || '';
            const trimmed = value.trim();
        
            if (switchingToRich) {
                const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(trimmed);
                const hasUnwrappedText = !looksLikeHtml || /^[^<]+|[^>]+$/g.test(trimmed);
        
                if (hasUnwrappedText) {
                const wrapped = `<p>${trimmed.replace(/\n+/g, '</p><p>')}</p>`;
                return {
                    ...prevFormData,
                    [fieldKey]: wrapped,
                };
                }
        
                return prevFormData;
            } else {
                return {
                ...prevFormData,
                [fieldKey]: isEditorEmpty(value) ? '' : value,
                };
            }
            });
        
            return {
            ...prev,
            [field]: switchingToRich,
            };
        });
    };
    
    
    const isEditorEmpty = (html) => {
        const cleaned = html.trim();
        return (
            cleaned === '' ||
            cleaned === '<p><br></p>' ||
            cleaned === '<p></p>' ||
            cleaned === '<br>' ||
            cleaned === '<p><br></p><p><br></p>'
        );
    };
    
    
    
    const onEditorChange = (field, value) => {
        const cleanedValue = isEditorEmpty(value) ? '' : value;
        setFormData(prev => ({ ...prev, [field]: cleanedValue }));
    };
    
    const[success,setSuccess] = useState({});
    const [statelist, setStateList] = useState({});
    const [countrieslist, setCountriesList] = useState({});
    const[salespersonList, setSalespersonList] = useState({});
    const [file, setFile] = useState({});
    const domain_url = configData.DOMAIN_URL;
    const app_url = configData.APP_URL;
    const loggedin_uid = localStorage.getItem('drupal_uid');
    const [showPasswordSuggestions, setShowPasswordSuggestions] = useState(false);
    const [passwordStrength, setPasswordStrength] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [swalProps, setSwalProps] = useState({});
    const[rolesList, setRolesList] = useState({});
    const [selectedRoles, setSelectedRoles] = useState(['2']);
    const [selected, setSelected] = useState([]);
    const [courseList, setCourseList] = useState([]);
    const [sortFlagOptions, setSortFlagOptions] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [pages, setPages] = useState([]);

    const [previewImageUrl, setPreviewImageUrl] = useState("/basic/web/images/notavailable.jpg");
    const [showDeletePictureCheckbox, setShowDeletePictureCheckbox] = useState(false);
    
    const [selectedAgentImage, setSelectedAgentImage] = useState(null);
    const [tempAgentImage, setTempAgentImage] = useState(null);
    const [agentImageRemoved, setAgentImageRemoved] = useState(false);
    const [selectedScoutImage, setSelectedScoutImage] = useState(null);
    const [tempScoutImage, setTempScoutImage] = useState(null);
    const [scoutImageRemoved, setScoutImageRemoved] = useState(false); 
    const [selectedMentorImage, setSelectedMentorImage] = useState(null);
    const [tempMentorImage, setTempMentorImage] = useState(null);
    const [mentorImageRemoved, setMentorImageRemoved] = useState(false);
    const [agentImageError, setAgentImageError] = useState(null);
    const [scoutImageError, setScoutImageError] = useState(null);
    const [mentorImageError, setMentorImageError] = useState(null);

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [fileInputKey, setFileInputKey] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');
    const [agentuploadFiles, setAgentUploadedFiles] = useState([]);

    const [scoutSelectedFiles, setScoutSelectedFiles] = useState([]);
    const [scoutUploadedFiles, setScoutUploadedFiles] = useState([]);
    const [scoutFileInputKey, setScoutFileInputKey] = useState(0);
    const [scoutErrorMessage, setScoutErrorMessage] = useState('');
    const [scoutcontractuploadFiles, setScoutContractUploadedFiles] = useState([]);

    const [athleteSelectedFiles, setAthleteSelectedFiles] = useState([]);
    const [athleteUploadedFiles, setAthleteUploadedFiles] = useState([]);
    const [athleteFileInputKey, setAthleteFileInputKey] = useState(0);
    const [athleteErrorMessage, setAthleteErrorMessage] = useState('');
    const [athletecontractuploadFiles, setAthleteContractUploadedFiles] = useState([]);

    const [athleteType, setAthleteType] = useState({});
    const [athletesportList, setAthleteSportList] = useState({});

    const [leadList, setLeadList] = useState({});
    const[sportsfocus, setSportsFocus] = useState({});
    const[SportsyouWorked, setSportsYouWorked] = useState({});
    const[dreamJob, setDreamJob] = useState({});
    const[specialcertificatelist, setAgentSpecialCertificateList] = useState({});
    const[degreesList, setDegreeList] = useState({});
    const[agentlist, setAgentList] = useState([]);
    const[docTalkList, setDocTalkList] = useState({});

    const [agentsportList, setAgentSportList] = useState('');
    const [scoutsportList, setScoutSportList] = useState({});

    const formatTime = (date = new Date(), withSeconds = true) => {
        const pad = (n) => String(n).padStart(2, "0");
        const hh = pad(date.getHours());
        const mm = pad(date.getMinutes());
        const ss = pad(date.getSeconds());
        return withSeconds ? `${hh}:${mm}:${ss}` : `${hh}:${mm}`;
    };
    const [initialTime, setInitialTime] = useState("");      // For HH:MM:SS
    const [initialDobTime, setInitialDobTime] = useState(""); // For HH:MM
    const [inputValue, setInputValue] = useState("");       // if you need for controlled input

    useEffect(() => {
    const now = new Date();
    setInitialTime(formatTime(now, true));   // HH:MM:SS
    setInitialDobTime(formatTime(now, false)); // HH:MM
    setInputValue(formatTime(now, true));   // Default input with HH:MM:SS
    }, []);

    const [toggles, setToggles] = useState({
        // timeZone: true,
        appliedCoursesList: false,
        sortFlagList: false,
        docTalkList: false,
        agentFields: false,
        scoutFields: false,
        mentorFields: false,
        applicationFields: false,
        athleteFields: false,
        eventAttendee: false,
        leadFields: false,
    });

    const handleToggle = (key) => {
        setToggles((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const handleSportsyouWorkedChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, field_sports_you_worked: selectedValues }));
    };
    const handleDreamJobChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, field_your_dream_job: selectedValues }));
    };

    const handleAddPlacement = () => {
        setFormData((prev) => ({
        ...prev,
        placements: [...prev.placements, { page: '', order: '1' }],
        }));
    };

    const handleDeletePlacement = (index) => {
        const updated = formData.placements.filter((_, i) => i !== index);
        setFormData((prev) => ({ ...prev, placements: updated }));
    };

    const handlePlacementChange = (index, field, value) => {
        const updated = [...formData.placements];
        updated[index][field] = value;
        setFormData((prev) => ({ ...prev, placements: updated }));
    };

    const handleSportsFocusChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, field_sports_focus: selectedValues }));
    };
    const handleAgentRepresentChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, field_agents_represented_by: selectedValues }));
    };
    const handleAthleteSportChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, field_athlete_sports: selectedValues }));
    };
    const getCurrentDateFormatted = () => {
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();
        return `${yyyy}-${mm}-${dd}`;
    };
    const currentFormattedDate = getCurrentDateFormatted();

    const getCurrentBDateFormatted = () => {
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
    };
    const currentFormattedBDate = getCurrentBDateFormatted();  

useEffect(() => {
    const processData = () => {
    if (userAgentAssets.length > 0) {
      userAgentAssets.forEach(item => {
        if (item['key'] === 'field_agent_contract') {
          setAgentUploadedFiles(item['full_value']);
        }
        else if (item['key'] === 'field_agent_expiration_date' && item['value']) {
          const dateString = item['value'];
        const [date] = dateString.split(" ");
        const [year, month, day] = date.split("-");
            setFormData(prev => ({ ...prev, 
                field_agent_expiration_year:year,
                 field_agent_expiration_month:month,
                field_agent_expiration_date:day,
            
            }));
            // setFormData(prev => ({
            //     ...prev,
            //     field_agent_expiration_date: {
            //         ...prev.field_agent_expiration_date,
            //         year: year,
            //         month: month,
            //         day: day,
            //     },
            // }));
        }
        else {
          setFormData(prev => ({ ...prev, [item['key']]: item['value'] }));
        }
      });
    }
    if (userScoutAssets.length > 0) {
      userScoutAssets.forEach(item => {
        if (item['key'] === 'field_scout_contract') {
          setScoutContractUploadedFiles(item['full_value']);
        } else {
          setFormData(prev => ({ ...prev, [item['key']]: item['value'] }));
        }
      });
    }
    if (userAthleteAssets.length > 0) {
        userAthleteAssets.forEach(item => {
            if (item['key'] === 'field_athlete_contract') {
            setAthleteContractUploadedFiles(item['full_value']);
            } 
            else
                if (item['key'] === 'field_date_of_assignment' || item['key'] === 'field_date_of_signing' || item['key'] === 'field_tier_status_date' || item['key'] === 'field_dob') {
            if(item['value']) {
                setFormData(prev => ({
                ...prev,
                [item['key']]: {
                    ...prev[item['key']],
                    date: `${item['date']}`,
                    time: `${item['time']}`,
                },
                }))
            }
        
            }
            else {
            setFormData(prev => ({ ...prev, [item['key']]: item['value'] }));
            }
        });
    }
    if (userAmbassadorAssets.length > 0) {
        userAmbassadorAssets.forEach((item) => {
        
            
            setFormData((prevState) => ({ ...prevState, [item['key']]: item['value'] }));
        
        });
    }
    if (userLeadAssets.length > 0) {
      userLeadAssets.forEach(item => {
        if (item['key'] === 'field_call_back' && item['value']) {
            const dateString = item['value']; 
            const [date, time] = dateString.split(" "); 
            const [year, month, day] = date.split("-"); 
            const [hour, minute, second] = time.split(":");

            setFormData(prev => ({ 
                ...prev, 
                field_call_back_year: year, 
                field_call_back_month: month, 
                field_call_back_day: day, 
                field_call_back_hour: hour, 
                field_call_back_minute: minute, 
                field_call_back_second: second
            }));
        }
        else {       
          setFormData(prev => ({ ...prev, [item['key']]: item['value'] }));
        }
      });
    }
    if (userMentorAssets.length > 0) {
      userMentorAssets.forEach(item => {
        setFormData(prev => ({ ...prev, [item['key']]: item['value'] }));
        
      });
    }
    if (userEventAssets.length > 0) {
        userEventAssets.forEach(item => {
       
            setFormData(prev => ({ ...prev, [item['key']]: item['value'] }));
            
        });
    }
    };

  const promises = [
    retrieveUserDetails(),
    retrieveCountriesList(),
    retrieveStateList(),
    getsalespersonlist(),
    getroleslist(),
    getplacementlist(),
    getagentsportslist(),
    getscoutsportslist(),
    getfieldslist()
  ];

  processData(); // Sync processing
  //console.log(agentuploadFiles.length + "haiiii");

  Promise.all(promises)
    .then(() => {
      setIsLoading(false);
    })
    .catch(error => {
      console.error(error);
      // Handle error
    });
    
  },[]);
  async function retrieveUserDetails() {
    if(uid) {
       try {
        
    const response = await fetch(
      app_url+'editprofile/getusereditdetails?uid='+uid,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      if(responsedata.data.result) {
        Object.keys(responsedata.data.result).forEach(function(key) {
          
          setFormData(prevState => ({
            ...prevState,
            [key]: responsedata.data.result[key]
          }));
       
        });
      
    }
    if(responsedata.data.sortflags) {
     setSortFlagOptions(responsedata.data.sortflags);
    }
     if(responsedata.data.courses) {
     setCourseList(responsedata.data.courses);
    }
    console.log(formData);
    }
    } catch (error) {
        console.error(error);
      }finally {
             // Set loading to false after fetch completes (success or error)
          }
  }
  }
  async function retrieveStateList() {
     try {
       
    const statelistresponse = await fetch(app_url + 'smwwstates/getstatelist', {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const statelistdata = await statelistresponse.json();
    const statelist = {};
    Object.keys(statelistdata.data.result).forEach(function(key) {
      statelist[key] = statelistdata.data.result[key];
    });
    setStateList(statelist);
   } catch (error) {
        console.error(error);
      }finally {
           
          }
  }
async function getagentsportslist() {
    
         try {
            const response = await fetch(
                app_url+'smwwagency/agentsports',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            
                setAgentSportList(responsedata.data);
               
            } 
        } catch (err) {
            
         }
        
  }
 
  async function getscoutsportslist() {
    
         try {
            const response = await fetch(
                app_url+'smwwscout/scoutsports',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            
                setScoutSportList(responsedata.data);
               
            } 
        } catch (err) {
            
         }
        
  }
   async function getfieldslist() {
    
         try {
            const response = await fetch(
                app_url+'smwwfieldlist/getfieldlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            
               setAthleteType(responsedata.data.athletetype);
               setAthleteSportList(responsedata.data.athletesport);
               setLeadList(responsedata.data.leadtype);
               setSportsFocus(responsedata.data.sportsfocus);
               setSportsYouWorked(responsedata.data.sportsworked);
               setDreamJob(responsedata.data.dreamjob);
               setAgentSpecialCertificateList(responsedata.data.agentspecialcertifications);
               setDegreeList(responsedata.data.degreeslist);
               setAgentList(responsedata.data.agentlist);
               setDocTalkList(responsedata.data.doctalk);
            } 
        } catch (err) {
            
         }
        
  }
  async function retrieveCountriesList() {
     try {
      
    const countrieslistresponse = await fetch(app_url + 'smwwcountries/getcountrieslist', {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const countrieslistdata = await countrieslistresponse.json();
    const countrieslist = {};
    Object.keys(countrieslistdata.data.result).forEach(function(key) {
      countrieslist[key] = countrieslistdata.data.result[key];
    });
    setCountriesList(countrieslist);
    } catch (error) {
        console.error(error);
      }finally {
           
          }
  }
   async function getsalespersonlist() {
    
        try {
      
            const response = await fetch(
                app_url+'user/getsalespersonlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (error) {
        console.error(error);
      }finally {
            
          }
        
  }
  async function getroleslist() {
    
         try {
         
            const response = await fetch(
                app_url+'user/getroleslist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setRolesList(responsedata.data.result);
                console.log(rolesList.length);
               
            } 
        } catch (error) {
        console.error(error);
      }finally {
           
          }
        
  }
  async function getplacementlist() {
    
         try {
            const response = await fetch(
                app_url+'node/getnodepages',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setPages(responsedata.data.result);
               
            } 
        } catch (err) {
            
        }
        
  }

    const isValidBasicPhone = (phone) => {
        const cleaned = phone.replace(/\D/g, ''); // Remove non-digit characters
        return cleaned.length >= 7 && cleaned.length <= 15;
    };
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const validateForm = (data) => {
        const errors = [];
        const newFieldErrors = { userName: false , mail: false, field_smww_email: false, field_realemail: false }; 
        if (!data.mail.trim()) {      
            errors.push("E-mail address field is required.");
            newFieldErrors.mail = true;
        }
        // --- Email format check ---
        else if (!isEmail.test(data.mail.trim())) {
            errors.push("Invalid e-mail address format.");
            newFieldErrors.mail = true;
        }
        // --- Agency-scout email ---
        if (data.field_smww_email && data.field_smww_email.trim() !== "") {
            if (!isEmail.test(data.field_smww_email.trim())) {
                errors.push("Invalid Agency-scout e-mail address format.");
                newFieldErrors.field_smww_email = true;
            }
        }

        // --- Real email ---
        if (data.field_realemail && data.field_realemail.trim() !== "") {
            if (!isEmail.test(data.field_realemail.trim())) {
                errors.push("Invalid Real e-mail address format.");
                newFieldErrors.field_realemail = true;
            }
        }

        // Username
        if (!data.userName || data.userName.trim() === '') {
            errors.push("Username field is required.");
            newFieldErrors.userName = true;
        } else {
            if (data.userName.startsWith(' ')) {
            errors.push("The username cannot begin with a space.");
            newFieldErrors.userName = true;
            }
        
        }

        //  set just the userName field error tracking
        setFieldErrors(newFieldErrors);

        if (data.password) {
            if(userLoggedInRoles.includes(configData.ROLE_APPLICATION) && loggedin_uid == uid) {
                if(!data.current_pass) {
                    errors.push("Please fill in Current Password.");
                }
            }
            if(!data.confirmPassword) {
                errors.push("Please fill in Confirm Password.");
            }
            if(data.password != data.confirmPassword) {
                errors.push("The specified passwords do not match.");
            }
        }
        if(data.field_linkedin_url !== null) {
            if(data.field_linkedin_url.trim() !== '') {
                var linkedinurl = data.field_linkedin_url.toLowerCase();
                if (linkedinurl.includes("linkedin.com/") === false) {
                    errors.push('Please enter a valid LinkedIn URL');  
                }
            }
        }
        // Instagram
        if (data.field_instagram_url && data.field_instagram_url.trim() !== '') {
            let url = data.field_instagram_url.toLowerCase();
            if (!url.includes("instagram.com/")) {
            errors.push("Please enter a valid Instagram URL");
            }
        }

        // Facebook
        if (data.field_facebook_url && data.field_facebook_url.trim() !== '') {
            let url = data.field_facebook_url.toLowerCase();
            if (!url.includes("facebook.com/")) {
            errors.push("Please enter a valid Facebook URL");
            }
        }

        // Twitter (X)
        if (data.field_twitter_url && data.field_twitter_url.trim() !== '') {
            let url = data.field_twitter_url.toLowerCase();
            if (!url.includes("twitter.com/") && !url.includes("x.com/")) {
            errors.push("Please enter a valid Twitter URL");
            }
        }

        // YouTube
        if (data.field_user_youtube_url && data.field_user_youtube_url.trim() !== '') {
            let url = data.field_user_youtube_url.toLowerCase();
            if (!url.includes("youtube.com/") && !url.includes("youtu.be/")) {
            errors.push("Please enter a valid YouTube URL");
            }
        }

        // TikTok
        if (data.field_tiktok_url && data.field_tiktok_url.trim() !== '') {
            let url = data.field_tiktok_url.toLowerCase();
            if (!url.includes("tiktok.com/")) {
            errors.push("Please enter a valid TikTok URL");
            }
        }
    
        if (data.field_phone) {
            if(data.field_phone.trim()) {
                if (!isValidBasicPhone(data.field_phone)) {
                    errors.push('Invalid Primary Phone Number');
                }
            }
        }
        if (data.field_secondary_phone) {
            if(data.field_secondary_phone.trim()) {
                if (!isValidBasicPhone(data.field_secondary_phone)) {
                    errors.push('Invalid Secondary Phone Number');
                }
        }
        }
        if (data.field_night_phone) {
            if(data.field_night_phone.trim()) {
                if (!isValidBasicPhone(data.field_night_phone)) {
                    errors.push('Invalid Night Phone Number');
                }
            }
        }

        return errors; 
    } 
  

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === "checkbox") {
            const arrayFields = [
                "applied_courses",
                "sort_flags",
                "field_lead_type",
                "field_agent_sports",
                "field_agent_certifications",
                "field_special_certifications",
                "field_scout_sport",
                "field_cuc_degrees",
                "field_doc_talk",
                "field_mentor_sports"
            ];

            if (arrayFields.includes(name)) {
            setFormData((prev) => {
                let current = [...(prev[name] || [])].map(String);
                const stringValue = String(value);

                if (checked && !current.includes(stringValue)) {
                current.push(stringValue);
                } else if (!checked) {
                current = current.filter((item) => item !== stringValue);
                }

                return {
                ...prev,
                [name]: current,
                };
            });

            return;
            }

            // Boolean fields
            setFormData((prev) => ({
            ...prev,
            [name]: checked ? 1 : 0,
            }));

            return;
        }

        // Non-checkbox fields
        if (name === "password") {
            setPasswordStrength(calculatePasswordStrength(value));
        }

        setFormData((prev) => {
            const updated = { ...prev };

            if (name.includes(".")) {
            const [parent, child] = name.split(".");
            let finalValue = value;

            if (name === "field_dob.time" && value?.length >= 5) {
                finalValue = value.substring(0, 5);
            }

            updated[parent] = {
                ...prev[parent],
                [child]: finalValue,
            };
            } else {
            updated[name] = value;
            }

            return updated;
        });
    };
    const handleRolesChange = (e) => {
        const { value, checked } = e.target;
        const isChecked = checked;
        if(isChecked){
            setFormData(prevState => ({ 
            ...prevState, 
            roles: [...prevState.roles, Number(value)] 
            }));
        } else {
            setFormData(prevState => {
            const updatedRoles = prevState.roles.filter(role => role !== Number(value));
            return { ...prevState, roles: updatedRoles };
            });
        }
    };

    const handleDateChange = (date) => {
        const formattedDate = format(date, "yyyy-MM-dd "); // Example: 2025-06-21 11:03:00
        setFormData(prev => ({
            ...prev,
            field_birthday: formattedDate
        }));
    }

    const calculatePasswordStrength = (password) => {
        if (password.length < 6) return 'Weak';
        if (password.length >= 6 && /[A-Z]/.test(password) && /[a-z]/.test(password) && /\d/.test(password) && /[^A-Za-z0-9]/.test(password)) {
        return 'Strong';
        }
        return 'Fair';
    };

    const [rules, setRules] = useState({
        length: false,
        lowercase: false,
        uppercase: false,
        number: false,
        special: false
    });

    const validatePassword = (password) => {
        setRules({
        length: password.length >= 6,
        lowercase: /[a-z]/.test(password),
        uppercase: /[A-Z]/.test(password),
        number: /\d/.test(password),
        special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
        });
    };

    const allRulesPassed = Object.values(rules).every(Boolean);

const fileInputRef = useRef();

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const errors = [];

        if (!file.type.startsWith("image/")) {
            errors.push("Only files with the following extensions are allowed: png, gif, jpg, jpeg.");
            e.target.value = null;
            showErrors(errors);
            return;
        }

        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            const { width, height } = img;

            if (width < 100 || height < 100) {
            errors.push("Image is too small. Minimum size is 100×100 pixels.");
            }

            if (width > 1000 || height > 1000) {
            errors.push("Image is too large. Maximum size is 1000×1000 pixels.");
            }

            // URL.revokeObjectURL(objectUrl);

            if (errors.length > 0) {
            e.target.value = null;
            showErrors(errors);
            if (fileInputRef.current) fileInputRef.current.value = "";
            return;
            }

            // Valid file: update state
            setFile(file);
            setPreviewImageUrl(objectUrl);
            // setShowDeletePictureCheckbox(true);

            setFormData((prev) => ({
            ...prev,
            picture: file,
            pictureDelete: false, // Reset delete checkbox if a new file is selected
            }));
        };

        img.onerror = () => {
            errors.push("Failed to load image. Please choose a valid image file.");
            e.target.value = null;
            URL.revokeObjectURL(objectUrl);
            showErrors(errors);
        };

        img.src = objectUrl;
    };

useEffect(() => {
  if (picture) {
    setPreviewImageUrl(picture);
    setShowDeletePictureCheckbox(true);
  } else {
    setPreviewImageUrl("/basic/web/images/notavailable.jpg");
  }
  console.log(formData);
}, [picture]);

    const showErrors = (errors) => {
        setError(errors); 
        window.scrollTo(0, 0);
    };

    const handleDeleteCheckboxChange = (e) => {
        const isChecked = e.target.checked;

        setFormData((prev) => ({
            ...prev,
            pictureDelete: isChecked,
            picture: isChecked ? null : prev.picture,
        }));

        if (isChecked) {
            setFile(null);
            setPreviewImageUrl("/basic/web/images/notavailable.jpg");
            // setShowDeletePictureCheckbox(false);
            if (fileInputRef.current) fileInputRef.current.value = "";
        }
    };

    const handleUserRoleFileChange = (e, setTempImageCallback, setImageRemovedCallback, setErrorCallback) => {
        const file = e.target.files[0];
        if (!file) return;

        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        const maxSize = 128 * 1024 * 1024; // 128 MB
        const errors = [];

        if (!validTypes.includes(file.type)) {
            errors.push('Allowed file types: png, gif, jpg, jpeg.');
        }

        if (file.size > maxSize) {
            errors.push('File must be less than 128 MB.');
        }

        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            const { width, height } = img;

            if (width < 100 || height < 100 || width > 1000 || height > 1000) {
                errors.push('Image size must be 100×100 px or 1000×1000 px.');
            }

            URL.revokeObjectURL(objectUrl);

            if (errors.length > 0) {
                setErrorCallback?.(errors.join('<br />'));
                e.target.value = '';
                setTempImageCallback(null);
            } else {
                setTempImageCallback(file);      
                setErrorCallback?.(null);         
                setImageRemovedCallback?.(false);
            }
        };

        img.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            setErrorCallback?.('Failed to load image. Please choose a valid image file.');
            e.target.value = '';
            setTempImageCallback(null);
        };

        img.src = objectUrl;
    };

    const handleUserRoleImageUpload = (tempImage, setSelectedImageCallback, setTempImageCallback) => {
        if (!tempImage) return;

        setSelectedImageCallback(tempImage);
        setTempImageCallback(null); // Clear temp after "upload"
    };

    const removeImage = (setImageStateCallback, setImageRemovedCallback, setErrorCallback) => {
        setImageStateCallback(null);
        setImageRemovedCallback?.(true);
        setErrorCallback?.(null);
    };

    const handleCancel = async (e) => {
        e.preventDefault();
        const confirmed = window.confirm('Are you sure?');

        if (confirmed) {
        // User clicked "OK", proceed with the action
        window.location.href = "/user/"+uid;
        
        // Add your deletion logic here
        } else {
        // User clicked "Cancel"
        
        }
    }
    
//   // handler for timezone select
//   const handleTimezoneChange = (e) => {
//     const parsed = parseTimezone(e.currentTarget.value);
//     setFormData((prev) => ({ ...prev, timezone: parsed.value })); 
//   };
//   // Add current date, day, and time to each option
//   const optionsWithTime = useMemo(() => {
//     return baseOptions.map((option) => {
//       const now = new Date();
      
//       // Format date, day, and time in the target timezone
//       const formatted = new Intl.DateTimeFormat("en-US", {
//         weekday: "long",  // Mon, Tue, ...
//         year: "numeric",
//         month: "long",    // Jan, Feb, ...
//         day: "2-digit",
//         hour: "2-digit",
//         minute: "2-digit",
//         timeZone: option.value,
//       }).format(now);

//       return {
//         ...option,
//         label: `${option.label} - ${formatted}`
//       };
//     });
//   }, [baseOptions]);

//   // Add current date/time in the label for display only
//   const optionsWithTime = useMemo(() => {
//     return baseOptions.map((option) => {

//       const now = new Date();
//       const formatted = new Intl.DateTimeFormat("en-US", {
//         weekday: "short",
//         year: "numeric",
//         month: "short",
//         day: "2-digit",
//         hour: "2-digit",
//         minute: "2-digit",
//         timeZone: option.value,
//       }).format(now);

//       return {
//         ...option,
//         label: `${option.label}: ${formatted}`, // display current time
//       };
//     });
//   }, [baseOptions]);

// const handleTimezoneChange = (e) => {
//   const value = e.currentTarget.value; // the timezone string
//   const parsed = parseTimezone(value); // full object

//   const now = new Date();
//   const formatted = new Intl.DateTimeFormat("en-US", {
//     weekday: "long",
//     year: "numeric",
//     month: "long",
//     day: "2-digit",
//     hour: "2-digit",
//     minute: "2-digit",
//     timeZone: parsed.value,
//   }).format(now);
//   console.log(parsed);
//   setFormData({
//     ...formData,
//     timezone: {
//       ...parsed,
//       currentDateTime: formatted,
//     },
//   });
// };

// const handleTimezoneChange = (e) => {
//   const value = e.currentTarget.value; // timezone string
//   setFormData({
//     ...formData,
//     timezone: value, 
//   });
//   console.log("Selected timezone value:", value);
// };

const handleSubmit = async event => {
  event.preventDefault();
  const newErrors = validateForm(formData);
  setError(newErrors);

  if (Object.keys(newErrors).length === 0) {
    let finalFormData = { ...formData };
   // Helper function to format date and time fields
    const formatDateTimeField = (field) => {
      if (finalFormData[field]?.date && finalFormData[field]?.time) {
       const date = finalFormData[field].date;
console.log(date);
const time = finalFormData[field].time;

// Check if date is already in YYYY-MM-DD format
let formattedDate;
if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
  formattedDate = date;
} else if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
  const dateParts = date.split('-');
  formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
} else {
  throw new Error(`Invalid date format: ${date}`);
}

// Combine date and time
const combinedDateTime = `${formattedDate} ${time}`; 

// Log the formatted date and time
console.log(`Formatted ${field} before submit:`, combinedDateTime);

// Update the form data
finalFormData[field] = combinedDateTime;
      } else {
        finalFormData[field] = '';
      }
    };

    // Apply formatting to all relevant fields
    formatDateTimeField('field_date_of_signing');
    formatDateTimeField('field_date_of_assignment');
    formatDateTimeField('field_dob');
    formatDateTimeField('field_tier_status_date');


   
   // console.log("Before meta description check:", finalFormData.field_meta_description);

//     if (!finalFormData.field_meta_description?.trim()) {
//       finalFormData.field_meta_description = finalFormData.field_biography
//         ? finalFormData.field_biography.substring(0, 160)
//         : "";
//    //  console.log("Auto-filled meta description from biography:", finalFormData.field_meta_description);
//      } else {
//     //   console.log("Meta description was already filled:", finalFormData.field_meta_description);
//     }

   
   // console.log("Final formData being submitted:", finalFormData);

    setFormData(prevState => ({
      ...prevState,
      button_name: "Saving..."
    }));

    const postData = new FormData();
    postData.append("file", file);
    postData.append("field_agent_photo", selectedAgentImage);
     postData.append("field_scout_photo", selectedScoutImage);
     postData.append("field_mentor_photo", selectedMentorImage);
    uploadedFiles.forEach(file => postData.append('agentcontractfiles[]', file));
    scoutUploadedFiles.forEach(file => postData.append('scoutcontractfiles[]', file));
    athleteUploadedFiles.forEach(file => postData.append('athletecontractfiles[]', file)); 
    postData.append("formData", JSON.stringify(finalFormData));

    const response = await fetch(app_url + "editprofile/putusereditdetails", {
      method: "POST",
      body: postData,
    });

    const data = await response.json();

    if (data.data.msg === "Success") {
      retrieveUserDetails();
      setSuccess(data.data.result);

      setFormData(prevState => ({
        ...prevState,
        button_name: "Save"
      }));
      window.scrollTo(0, 0);
    } else {
      setError(data.data.result);
      window.scrollTo(0, 0);
    }
  } else {
    window.scrollTo(0, 0);
  }
};

    const validTypes = [
        'text/plain',
        'image/png',
        'image/jpeg',
        'image/jpg',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
    ];

    const maxSize = 128 * 1024 * 1024;

    // const getFileIcon = (fileName) => {
    // const extension = fileName.split('.').pop().toLowerCase();
    //     switch (extension) {
    //         case 'txt': return '/images/text-plain.png';
    //         case 'pdf': return '/images/application-pdf.png';
    //         case 'docx': return '/images/x-office-document.png';
    //         case 'jpg':
    //         case 'jpeg':
    //         case 'png': return '/images/image-x-generic.png';
    //         default: return '/images/image-x-generic.png';
    //     }
    // };
const getFileIcon = (fileName) => {
  if (!fileName || typeof fileName !== 'string') {
    return '/basic/web/images/image-x-generic.png';
  }

  const extension = fileName.split('.').pop().toLowerCase();

  switch (extension) {
    case 'txt': return '/basic/web/images/text-plain.png';
    case 'pdf': return '/basic/web/images/application-pdf.png';
    case 'docx': return '/basic/web/images/x-office-document.png';
    case 'jpg':
    case 'jpeg':
    case 'png': return '/basic/web/images/image-x-generic.png';
    default: return '/basic/web/images/image-x-generic.png';
  }
};

    const handleFileInputChange = (e, setSelected, setError, setKey) => {
        const files = Array.from(e.target.files);

        const validFiles = [];
        const invalidFiles = [];

        files.forEach(file => {
            const isValidType = validTypes.includes(file.type);
            const isValidSize = file.size <= maxSize;

            if (isValidType && isValidSize) {
            validFiles.push(file);
            } else {
            invalidFiles.push(file);
            }
        });

        if (invalidFiles.length > 0) {
            const names = invalidFiles.map(f => f.name).join(', ');
            setError(
            `The selected file${invalidFiles.length > 1 ? 's' : ''} ${names} cannot be uploaded. 
            Only files with the following extensions are allowed: txt, png, jpg, jpeg, pdf, docx.`
            );
            setKey(prev => prev + 1); // reset input
            setSelected([]);          // clear selection
        } else {
            setError('');
            setSelected(validFiles);
        }
    };
    const handleUpload = (selectedFiles, setUploaded, setError, setSelected, setKey) => {
        const newFiles = selectedFiles.filter(file => {
            const isValidType = validTypes.includes(file.type);
            const isValidSize = file.size <= maxSize;
            return isValidType && isValidSize;
        });

        setUploaded(prev => [...prev, ...newFiles]);
        setError('');
        setSelected([]);
        setKey(prev => prev + 1); // reset input
    };
    const removeFile = (index, setUploaded) => {
        setUploaded(prev => prev.filter((_, i) => i !== index));
    };
const removeAgentContractFile = (index,removed_fid) => {
        setAgentUploadedFiles(prev => prev.filter((_, i) => i !== index));
         setFormData(prev => ({
    ...prev,
    removed_agent_contract_fids: [...(prev.removed_fids || []), removed_fid]
  }));
    }; 
    const removeScoutContractFile = (index,removed_fid) => {
        setScoutContractUploadedFiles(prev => prev.filter((_, i) => i !== index));
         setFormData(prev => ({
    ...prev,
    removed_scout_contract_fids: [...(prev.removed_fids || []), removed_fid]
  }));
    }; 
     const removeAthleteContractFile = (index,removed_fid) => {
        setAthleteContractUploadedFiles(prev => prev.filter((_, i) => i !== index));
         setFormData(prev => ({
    ...prev,
    removed_athlete_contract_fids: [...(prev.removed_fids || []), removed_fid]
  }));
    };

    return (
        <>
        {isLoading ? (
            <Loading />
        ) : (
        <div className="edit-profile-container">
            {error.length > 0 && (
                    <div 
                        className="set-message-error" 
                        style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, padding: "10px 10px 10px 50px"}}
                    >
                    {error.map((item, index) => {
                    return <>{item}<br /></>
                    
                    })}  
                </div>
            )}
            {success.length > 0 && (
                <>
                    {success.map((item, index) => {
                        return <>
                        <br/><div className="set-message-done">
                            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {item}
                        </div></>
                    
                    })}  
                </>
            )}
            <SweetAlert2 {...swalProps} />
            {loggedin_uid && !Number.isNaN(loggedin_uid) ? (
                <form onSubmit={handleSubmit}>          
                    <>    
                        <div className="edit-profile-row"> 
                            <label>Username  <span className="form-required" title="This field is required.">*</span></label>
                            <input
                                type="text"
                                name="userName"
                                value={formData.userName}
                                onChange={handleChange}
                                className={fieldErrors.userName ? 'input-error' : ''}
                            />
                            <span className="edit-profile-desc">
                                Spaces are allowed; punctuation is not allowed except for periods, hyphens, apostrophes, and underscores.
                            </span>
                        </div>
                        <div className="edit-profile-row">
                            <label>E-mail address  <span className="form-required" title="This field is required.">*</span></label>
                            <input
                                type="email"
                                name="mail"
                                value={formData.mail}
                                onChange={handleChange}
                            />
                            <span className='edit-profile-desc'>
                                A valid e-mail address. All e-mails from the system will be sent to this address.
                                The e-mail address is not made public and will only be used if you wish to receive a new password or
                                wish to receive certain news or notifications by e-mail.
                            </span>
                        </div>
                        <div className="edit-profile-row">
                            <label>Password</label>
                            <div className="edit-profile-password-container">
                                <input
                                    className='edit-profile-password-box'
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFormData(prev => ({ ...prev, password: value }));
                                        setPasswordStrength(calculatePasswordStrength(value)); // if you're using this
                                        validatePassword(value);
                                    }}
                                    onFocus={() => setShowPasswordSuggestions(true)}
                                    onBlur={() => setShowPasswordSuggestions(false)}
                                />
                                <div className="edit-profile-password-strength">
                                    <span>Password strength: {passwordStrength}</span>
                                    <div className="strength-bar-bg">
                                        <div className={`strength-bar ${passwordStrength.toLowerCase()}`}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="edit-profile-row">
                            <label>Confirm password</label>
                            <div className='edit-profile-password-container'>
                            <input
                                className='edit-profile-password-box'
                                type="password"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setFormData(prev => ({ ...prev, confirmPassword: value }));
                                    validatePassword(value);
                                }}
                                // onFocus={() => setShowPasswordSuggestions(true)}
                                // onBlur={() => setShowPasswordSuggestions(false)}
                            />
                            {/* Match status */}
                            {formData.confirmPassword?.length > 0 && (
                                <div className="adduser-password-confirm adduser-form-item-password" style={{fontWeight: 'normal' }}>
                                    <div>
                                        Passwords match:{' '}
                                        {formData.password === formData.confirmPassword ? (
                                            <span style={{ color: 'green' }}>Yes</span>
                                        ) : (
                                            <span style={{ color: 'red' }}>No</span>
                                        )}
                                    </div>
                                </div>
                            )}
                            </div>
                            {/* {showPasswordSuggestions && (
                                <span className="edit-profile-password-suggn">
                                <p>To make your password stronger:</p>
                                <ul>
                                    <li>Make it at least 6 characters</li>
                                    <li>Add lowercase letters</li>
                                    <li>Add uppercase letters</li>
                                    <li>Add numbers</li>
                                    <li>Add punctuation</li>
                                </ul>
                                </span>
                            )} */}
                                  {showPasswordSuggestions
                                //    && formData.password.length > 0 
                                   && !allRulesPassed && (
                                    <div className="edit-profile-password-suggn">
                                        <p>To make your password stronger:</p>
                                        <ul>
                                            {!rules.length && <li>Make it at least 6 characters</li>}
                                            {!rules.lowercase && <li>Add lowercase letters</li>}
                                            {!rules.uppercase && <li>Add uppercase letters</li>}
                                            {!rules.number && <li>Add numbers</li>}
                                            {!rules.special && <li>Add punctuation</li>}
                                        </ul>
                                    </div>
                                )}
                            <span className="edit-profile-desc">
                                To change the current user password, enter the new password in both fields.
                            </span>
                        </div>

                        <div className="edit-profile-row">
                            <label>Status</label>
                            <div className="edit-profile-radio-group">
                                <div>
                                    <label>
                                        <input
                                            type="radio"
                                            name="status"
                                            value="0"
                                            checked={formData.status == '0'}
                                            onChange={handleChange}
                                        />
                                        <span className=''>Blocked</span>
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        <input
                                            type="radio"
                                            name="status"
                                            value="1"
                                            checked={formData.status == '1'}
                                            onChange={handleChange}
                                        /> 
                                        <span className=''>Active</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        
                        <div>
                            <label>Roles</label>                   
                            <div className='edit-profile-row-roles' style={{width: "60%"}}>
                                {rolesList.length > 0 && ( 
                                    <>
                                        {rolesList.map(({ id, name }) => (
                                    
                                            <label key={id}>
                                        
                                                <input
                                                    type="checkbox"
                                                    name="roles"
                                                    value={id}
                                                    defaultChecked={formData.roles.includes(id) || false}
                                                    disabled={id == "2" ? "true" : ""}
                                                    onChange={handleRolesChange}
                                                />
                                                {name}
                                            </label>

                                        ))}
                                    </>
                                )}
                            </div>
                        </div>

                        <fieldset className='admin-edit-profile-toggle'>
                            {/* <div className="edit-profile-row">
                                <label>Picture</label>
                                {formData.picture ? (  
                                    <><img  src={formData.picture} width="100px" height="100px" alt = "user"/></>
                                ):(
                                    <><img  src={domain_url+"pictures/notavailable.jpg"} width="100px" height="100px" alt = "user"/></>
                                )}
                                <br />
                                <input
                                    type="file"
                                    name="picture"
                                    onChange={handleFileChange}
                                />
                                <span className='edit-profile-desc'>
                                    Your virtual face or picture. Pictures larger than 1024x1024 pixels will be scaled down. 
                                    Image size must be a minimum of 100*100 px or a maximum of 1000*1000 px
                                </span>
                            </div> */}
                            <div>
                                <label>Picture</label>

                                <a href={"/user/"+uid+"/view"} target="_blank" rel="noopener noreferrer" style={{ cursor: "pointer", display: "inline-block" }}>
                                    <img
                                        src={
                                            formData.picture instanceof File
                                            // ? URL.createObjectURL(formData.picture)
                                            ? previewImageUrl
                                            : formData.picture || domain_url + "pictures/notavailable.jpg"
                                        }
                                        width="100px"
                                        height="100px"
                                        alt="user"
                                    />
                                </a>
                                <br />
                                {showDeletePictureCheckbox && (
                                    <>
                                    <input
                                        type="checkbox"
                                        id="edit-picture-delete"
                                        name="pictureDelete"
                                        checked={formData.pictureDelete}
                                        onChange={handleDeleteCheckboxChange}
                                    />
                                    <label htmlFor="edit-picture-delete" className="option" style={{fontWeight:"normal"}}>
                                        Delete picture
                                    </label>
                                    <div className="description">
                                        Check this box to delete your current picture.
                                    </div>
                                    </>
                                )}
                                <input
                                    type="file"
                                    name="picture"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    ref={fileInputRef}
                                    style={{marginTop: "5px"}}
                                />
                                <div className="edit-profile-desc">
                                    Your virtual face or picture. Pictures larger than 1024x1024 pixels will be scaled down. 
                                    Image size must be a minimum of 100*100 px or a maximum of 1000*1000 px
                                </div>
                            </div>
                        </fieldset>

                        <div className="form-checkbox">
                            <input
                                type="checkbox"
                                id="edit-field-add-to-divvy-draft"
                                name="field_add_to_divvy_draft"
                                value = "1" 
                                defaultChecked={formData.field_add_to_divvy_draft == "1" ? "true" : ""}
                                onChange={handleChange}
                                className="form-checkbox"
                            />
                            <label className="option" htmlFor="edit-field-add-to-divvy-draft">Include in Divvy Draft </label>
                        </div>

                        {/* <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("timeZone")} style={{color:"#0074bd", cursor:"pointer"}}>
                                <span style={{ fontSize: '10px',color:"#111" }}>{toggles.timeZone ? '▼ ' : '▶ '}</span> 
                                <span className="toggle-titles">LOCALE SETTINGS</span>
                            </span>
                            {toggles.timeZone && (
                                <div className="fieldset-wrapper" style={{margin: "1em 0"}}>
                                    <label htmlFor='edit-timezone--2'>Time zone</label>
                                    <select
                                    name="timezone"
                                    value={formData.timezone || ""}
                                    onChange={handleTimezoneChange}
                                    className='admin-profile-timezone-select'
                                    >
                                    <option value="">- None selected -</option>
                                    {optionsWithTime.map((option) => (
                                        <option key={option.value} value={option.value}>
                                        {option.label}
                                        </option>
                                    ))}
                                    </select>
                                    <div className="description">
                                        Select the desired local time and time zone. Dates and times throughout this site will be displayed using this time zone.
                                    </div>
                                </div>
                            )}
                        </fieldset> */}

                        <div className="edit-profile-row">
                            <label htmlFor="first_name">First Name</label>
                            <input className='' type="text" id="first_name" name="firstName" value={formData.firstName} onChange={handleChange} />
                        </div>

                        <div className="edit-profile-row">
                            <label htmlFor="last_name">Last Name</label>
                            <input className='' type="text" id="last_name" name="lastName" value={formData.lastName} onChange={handleChange}  /> 
                        </div>

                        <div className="edit-profile-row">
                            <label htmlFor="meta_title">Meta Title</label>
                            <input className='' type="text" id="meta_title" name="field_meta_title" value={formData.field_meta_title} onChange={handleChange}  /> 
                        </div>

                        <div className="edit-profile-row">
                            <label>What team/organization are you with?</label>
                            <input
                                type="text"
                                name="field_team_organization"
                                value={formData.field_team_organization}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="edit-profile-row">
                            <label htmlFor="meta_keywords">Meta Keywords</label>
                            <input className='' type="text" id="meta_keywords" name="field_meta_keywords" value={formData.field_meta_keywords} onChange={handleChange}  /> 
                        </div>

                        <div className="edit-profile-row">
                            <label>Meta Description</label>
                            <textarea
                                name="field_meta_description"
                                value={formData.field_meta_description}
                                onChange={handleChange}
                            />
                            <div className="grippie" 
                                style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                            >   
                            </div>
                            <div className='description'>    
                                If left blank, the first 160 characters of the biography will pull.
                            </div>
                        </div>

                        {/* Biography */} 
                        <div className="edit-profile-row">
                            <label>Biography</label>             
                            {editorMode.biography ? (               
                                <Editor value={formData.field_biography} onChange={e => onEditorChange('field_biography', e.target.value)} /> 
                            ) : (
                                <>	
                                    <textarea className="edit-agent-form-bio" value={formData.field_biography} onChange={e => onEditorChange('field_biography', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                </>
                            )}
                            <a onClick={() => toggleEditor('biography')}>Switch to {editorMode.biography ? 'Plain' : 'Rich'} Editor</a>
                        </div>

                        {/* Education */} 
                        <div className="edit-profile-row">
                            <label>Education</label>  
                            {editorMode.education ? (
                                <Editor value={formData.field_education} onChange={e => onEditorChange('field_education', e.target.value)} />
                            ) : (
                                <>	
                                    <textarea className="edit-agent-form-bio" value={formData.field_education} onChange={e => onEditorChange('field_education', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                </>
                            )} 
                            <a onClick={() => toggleEditor('education')}>Switch to {editorMode.education ? 'Plain' : 'Rich'} Editor</a>
                        </div>

                        {/* Career information */}          
                        <div className="edit-profile-row">
                            <label>Career information</label> 
                            {editorMode.careerinfo ? (			  
                                <Editor value={formData.field_career_information} onChange={e => onEditorChange('field_career_information', e.target.value)} />  
                            ) : (
                                <>	
                                    <textarea className="edit-agent-form-bio" value={formData.field_career_information} onChange={e => onEditorChange('field_career_information', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                </>
                            )}         
                            <a onClick={() => toggleEditor('careerinfo')}>Switch to {editorMode.careerinfo ? 'Plain' : 'Rich'} Editor</a>	            
                        </div>

                        {/* Sports Background */}
                        <div className="edit-profile-row">
                            <label>Sports Background</label>
                            <textarea
                                name="field_sports_background"
                                value={formData.field_sports_background}
                                onChange={handleChange}
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div>
                        </div>

                        {/* Professional Background */}
                        <div className="edit-profile-row">
                            <label htmlFor="edit-field-professional-background">Professional Background</label>
                            <textarea
                                name="field_professional_background"
                                value={formData.field_professional_background}
                                onChange={handleChange}
                                id="edit-field-professional-background"
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div>
                        </div>

                        {/* Volunteer Work */}
                        <div className="edit-profile-row">
                            <label htmlFor="edit-field-volunteer-work">Volunteer Work</label>
                            <textarea
                                name="field_volunteer_work"
                                value={formData.field_volunteer_work}
                                onChange={handleChange}
                                id="edit-field-volunteer-work"
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div>
                        </div>

                        {/* Mission Statement */}
                        <div className="edit-profile-row">
                            <label htmlFor="edit-field-mission-statement">Mission Statement</label>
                            <textarea
                                name="field_mission_statement"
                                value={formData.field_mission_statement}
                                onChange={handleChange}
                                id="edit-field-mission-statement"
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div>
                        </div>

                        {/* Revision information */}
                        <div className="edit-profile-row">
                            <fieldset className='admin-edit-profile-toggle'>
                            <p style={{marginTop: "0px", fontWeight: "bold"}}>REVISION INFORMATION</p>
                            <label>Revision log message</label>
                            <textarea
                                name="revision"
                                value={formData.revision}
                                onChange={handleChange}
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}>   
                            </div>
                            <div className='description'>    
                                Provide an explanation of the changes you are making. This will help other authors understand your motivations.
                            </div>
                            </fieldset>
                        </div>

                        <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("sortFlagList")} style={{color:"#0074bd", cursor:"pointer"}}>
                                <span style={{ fontSize: '10px',color:"#111" }}>{toggles.sortFlagList ? '▼ ' : '▶ '}</span> 
                                <span className="toggle-titles">SORT FLAGS</span>
                            </span>
                            {toggles.sortFlagList && (
                                <div className="sort-flag-list">
                                    <label style={{fontWeight: "bold", marginTop: "15px"}}>Sort flags</label>
                                    {sortFlagOptions.length > 0 && ( 
                                        <>
                                            {sortFlagOptions.map(({ id, tid, name }) => (
                                                <label key={id} className="checkbox-item">
                                                <input
                                                    type="checkbox"
                                                    name="sort_flags"
                                                    value={tid}
                                                    defaultChecked={formData.sort_flags.includes(tid) || false}
                                                    onChange={handleChange}
                                                />
                                                {name}
                                                </label>
                                            ))}
                                        </>
                                    )}
                                </div>
                            )}
                        </fieldset>

                        <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("docTalkList")} style={{color:"#0074bd", cursor:"pointer"}}>
                                <span style={{ fontSize: '10px',color:"#111" }}>{toggles.docTalkList ? '▼ ' : '▶ '}</span> 
                                <span className="toggle-titles">DOC TALKS</span>
                            </span>
                            {toggles.docTalkList && (
                                <div className="sort-flag-list">
                                    <label style={{fontWeight: "bold", marginTop: "15px"}}>DOC Talks</label>
                                    {Object.entries(docTalkList).length > 0 && (
                                        <>
                                            {Object.entries(docTalkList).map(([value, label]) => (
                                            <label key={value} className="sports-checkbox-item" style={{fontWeight:"normal"}}>
                                                <input
                                                    type="checkbox"
                                                    name="field_doc_talk"
                                                    // checked={formData.field_doc_talk?.includes(value)}  
                                                    defaultChecked={formData.field_doc_talk?.includes(value) || false}
                                                    value={value}
                                                    onChange={handleChange}
                                                />
                                                {label}
                                            </label>
                                            ))}
                                        </>
                                    )}
                                </div>
                            )}
                        </fieldset>

                        <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("agentFields")} style={{color:"#0074bd", cursor:"pointer"}}>
                                <span style={{ fontSize: '10px',color:"#111" }}>{toggles.agentFields ? '▼ ' : '▶ '}</span> 
                                <span className="toggle-titles">AGENT</span>
                            </span>
                            {toggles.agentFields && ( 
                                <>
                                    <div className="form-item">
                                        <input
                                            type="checkbox"
                                            id="edit-field-show-on-frontend-agent-und"
                                            name="field_show_on_frontend_agent"
                                            checked={formData.field_show_on_frontend_agent === 1}
                                            // defaultChecked={formData.field_show_on_frontend_agent === "1" ? "true":"false"}
                                            onChange={handleChange}
                                            className="form-checkbox"
                                        />
                                        <label className="option" htmlFor="edit-field-show-on-frontend-agent-und" style={{fontWeight:"normal"}}>
                                            Show on Frontend Agent
                                        </label>
                                    </div>

                                    <div className="form-item">
                                        <label htmlFor="edit-field-agent-sort-order-und">
                                            Agent Sort Order
                                        </label>
                                        <select
                                            id="edit-field-agent-sort-order-und"
                                            name="field_agent_sort_order"
                                            value={formData.field_agent_sort_order}
                                            onChange={handleChange}
                                        >
                                            <option value="">- None -</option>
                                            {Array.from({ length: 20}, (_, i) => {
                                                const sort = (i + 1).toString().padStart(1, '0');
                                                return <option key={sort} value={sort}>{sort}</option>;
                                            })}
                                        </select>
                                    </div>

                                    <div className="form-item">
                                        <label htmlFor="edit-field-agent-id">Agent ID #</label>
                                        <input 
                                            type="text" 
                                            id="edit-field-agent-id" 
                                            name="field_agent_id" 
                                            size={12} 
                                            maxLength={10}
                                            value={formData.field_agent_id}
                                            onChange={handleChange} 
                                        />
                                    </div>

                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-agent-job-title">Agent Job Title</label>
                                        <input
                                            type="text"
                                            id="edit-agent-job-title"
                                            name="field_agent_title"
                                            maxLength={255}
                                            value={formData.field_agent_title}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-agent-biography">Agent Biography</label>
                                        <div>
                                            {editorMode.agentBio ? (
                                                <Editor 
                                                    containerProps={{ style: { resize: 'vertical' } }}
                                                    value={formData.field_agent_biography} 
                                                    onChange={e => onEditorChange('field_agent_biography', e.target.value)} 
                                                />  
                                            ) : (
                                                <>
                                                    <textarea
                                                        className="edit-agent-form-bio"
                                                        id="edit-agent-biography"
                                                        name="field_agent_biography"
                                                        value={formData.field_agent_biography} 
                                                        rows={5}
                                                        // onChange={(e) => setFormData((prev) => ({ ...prev, field_agent_biography: e.target.value })) }
                                                        onChange={e => onEditorChange('field_agent_biography', e.target.value)}
                                                    />
                                                    <div
                                                        className="grippie"
                                                        style={{ background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px` }}
                                                    >
                                                    </div>
                                                </>
                                            )}
                                            <a onClick={() => toggleEditor('agentBio')}>Switch to {editorMode.agentBio ? 'Plain' : 'Rich'} Editor</a>	
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="edit-agent-photo-upload">Agent Photo</label>
                                        <div>
                                            {agentImageError && (
                                                <div 
                                                    style={{ color: '#d9534f', 
                                                    border: '1px solid #d9534f',
                                                    backgroundColor: '#fef5f1', 
                                                    padding: '10px 10px 10px 50px', 
                                                    marginBottom: '10px',
                                                    width: '90%', 
                                                    borderRadius: '5px',
                                                    background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat` }}
                                                    dangerouslySetInnerHTML={{ __html: agentImageError }}
                                                >
                                                </div>
                                            )}
                                            {formData.field_agent_photo ? (
                                                <>
                                                    <div>
                                                        <img
                                                            alt="Uploaded"
                                                            src={formData.field_agent_photo}
                                                            width="90" height="100"
                                                            style={{float: "left"}}
                                                        />
                                                        <div className="image-info" style={{float: "left", margin: "5px"}}>
                                                            <a
                                                                href={formData.field_agent_photo}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="image-name-link"
                                                            >
                                                                <img
                                                                    src={getFileIcon(formData.field_agent_photo)}
                                                                    alt="File Icon"
                                                                    style={{ width: '16px', height: '16px', marginRight: '5px', verticalAlign: 'middle' }}
                                                                />
                                                                {formData.field_agent_photo.replace("/basic/web/pictures/", "")}
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <input
                                                        type="button"
                                                        value="Remove"
                                                        className="form-submit"
                                                        onClick={() => setFormData((prev) => ({ ...prev, field_delete_agent_photo:1,field_agent_photo:'' }))}
                                                    />
                                                </>
                                            ) : selectedAgentImage ? (
                                                <>
                                                    <div>
                                                        <img alt="Uploaded" src={URL.createObjectURL(selectedAgentImage)} style={{float: "left"}} width="90" height="100" />
                                                        <div className="image-info" style={{float: "left", margin: "5px"}}>
                                                            <a
                                                                href={URL.createObjectURL(selectedAgentImage)}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="image-name-link"
                                                            >
                                                                <img
                                                                    src={getFileIcon(selectedAgentImage.name)}
                                                                    alt="File Icon"
                                                                    style={{ width: '16px', height: '16px', marginRight: '5px', verticalAlign: 'middle' }}
                                                                />
                                                                {selectedAgentImage.name}
                                                            </a>
                                                            <span className="image-size">
                                                                ({(selectedAgentImage.size / 1024).toFixed(2)} KB)
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <input
                                                        type="button"
                                                        value="Remove"
                                                        className="form-submit"
                                                        onClick={() => removeImage(setSelectedAgentImage, setAgentImageRemoved, setAgentImageError)}
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    <input
                                                        type="file"
                                                        id="edit-agent-photo-upload"
                                                        name="field_agent_photo" 
                                                        accept="image/*"
                                                        onChange={(e) => 
                                                            handleUserRoleFileChange(e,setTempAgentImage, setAgentImageRemoved, setAgentImageError)}
                                                    />
                                                    <input
                                                        type="button"
                                                        value="Upload"
                                                        className="form-submit"
                                                        onClick={() => {
                                                            if (tempAgentImage) {
                                                                handleUserRoleImageUpload(
                                                                    tempAgentImage,
                                                                    setSelectedAgentImage,
                                                                    setTempAgentImage
                                                                );
                                                            } else {
                                                                document.getElementById('edit-agent-photo-upload')?.click();
                                                            }
                                                        }}
                                                    />
                                                </>
                                            )}
                                        </div>
                                        <div style={{clear: "both"}}></div>
                                        <div className="description">
                                            Image size must be a minimum of 100*100 px or a maximum of 1000*1000 px<br />
                                            Files must be less than <b>128 MB</b>.<br />
                                            Allowed file types: <b>png gif jpg jpeg</b>.
                                        </div>
                                    </div>

           {/* Agent Contract */}
            <div className="edit-profile-row">
              <div>
                <fieldset>
                  <legend>
                    <span style={{fontWeight:"700"}}>Agent Contract</span>
                  </legend>
                  <div>
                     {(uploadedFiles?.length > 0 || agentuploadFiles?.length > 0) && (
                      <table style={{fontSize:"14px", width:"90%"}}>
                        <thead>
                          <tr style={{textAlign:"left"}}>
                            <th>File information</th>
                            <th>Operations</th>
                          </tr>
                        </thead>
                        <tbody style={{backgroundColor: "#eee"}}>
                           {uploadedFiles.length > 0 && uploadedFiles.map((file, index) => (
                            <tr key={index} style={{borderBottom: "1px solid #ccc"}}>
                              <td>
                                <span>
                                  <img
                                    alt="File icon"
                                    src={getFileIcon(file.name)}
                                    style={{ marginRight: '8px' }}
                                  />
                                  <a href={URL.createObjectURL(file)} target="_blank" rel="noreferrer">
                                    {file.name}
                                  </a>
                                </span>
                                <span> ({(file.size / 1024).toFixed(2)} KB)</span>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className="form-submit"
                                 onClick={() => removeFile(index, setUploadedFiles)}
                                >
                                  Remove
                                </button>
                              </td>
                            </tr>
                          ))}
                                    {agentuploadFiles && 
                                                 agentuploadFiles.length > 0 && agentuploadFiles.map((file, index) => (
                                                <tr key={index} style={{borderBottom: "1px solid #ccc"}}>
                                                    <td>
                                                    <span className="file">
                                                        <img
                                                            className="file-icon"
                                                            alt="File icon"
                                                            src={getFileIcon(file.name)}
                                                            style={{ marginRight: '8px' }}
                                                        />
                                                        <a href={file.url} target="_blank" rel="noreferrer">
                                                        {file.name}
                                                        </a>
                                                    </span>
                                                    <span> ({(file.size / 1024).toFixed(2)} KB)</span>
                                                    </td>
                                                    <td>
                                                    <button
                                                        type="button"
                                                        className="form-submit"
                                                        onClick={() => removeAgentContractFile(index,file.fid)}
                                                    >
                                                        Remove
                                                    </button>
                                                    </td>
                                                </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        )}
                                        {errorMessage && (
                                        <div 
                                            className="set-message-error" 
                                            style={{ 
                                            background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, 
                                            padding: "10px 10px 10px 50px",
                                            width: "90%",
                                            }}
                                        >
                                            {errorMessage}
                                        </div>
                                        )}
                                        <div className="form-item">
                                        <label htmlFor="edit-field-agent-contract">Add a new file</label>
                                        <div>
                                            <input
                                            type="file"
                                            id="edit-field-agent-contract"
                                            name="field_agent_contract"
                                            multiple
                                            onChange={(e) => handleFileInputChange(e, setSelectedFiles, setErrorMessage, setFileInputKey)}
                                            key={fileInputKey}
                                            style={{width: "auto"}}
                                            />
                                            <button type="button" onClick={() => handleUpload(selectedFiles, setUploadedFiles, setErrorMessage, setSelectedFiles, setFileInputKey)} disabled={selectedFiles.length === 0} className="form-submit">
                                            Upload
                                            </button>
                                        </div>
                                        <div className="description">
                                            Files must be less than <strong>128 MB</strong>.<br />
                                            Allowed file types: <strong>txt, png, jpg, jpeg, pdf, docx</strong>.
                                        </div>
                                        </div>
                                    </div>
                                    </fieldset>
                                </div>
                                </div>

                                    {/* Agent Sports */}
                                    <div className='form-item' style={{width: "50%"}}>
                                        <label htmlFor="field-agent-sports">Agent Sports </label>    
                                        {agentsportList.length > 0 && (
                                        <>
                                            {agentsportList.map((sportName) => (
                                            <label key={sportName} className="sports-checkbox-item" style={{fontWeight:"normal"}}>
                                                <input
                                                    type="checkbox"
                                                    name="field_agent_sports"
                                                    value={sportName.key}
                                                    onChange={handleChange}
                                                    checked={formData.field_agent_sports?.includes(sportName.key)}                                           
                                                    className="sport-list-input"
                                                />
                                                {sportName.value}
                                            </label>
                                            ))}
                                        </>
                                        )}
                                    </div>

                                    <div className="form-item" style={{width: "50%"}}>
                                        <label htmlFor="field-agent-certifications">Agent Certifications </label>
                                        {agentCertificateList.length > 0 && (
                                            <>
                                                {agentCertificateList.map((certificateName) => (
                                                    <label key={certificateName} style={{fontWeight: "normal"}}>
                                                        <input
                                                            type="checkbox"
                                                            name="field_agent_certifications"
                                                            value={certificateName}
                                                            checked={formData.field_agent_certifications?.includes(certificateName)}
                                                            onChange={handleChange}    
                                                        />
                                                        {certificateName}
                                                    </label>
                                                ))}
                                            </>
                                        )}
                                    </div>

                                    {/* Special Certifications */}
                                    <div className='form-item' style={{width: "65%"}}>
                                        <label htmlFor="edit-field-special-certifications">Special Certifications </label>
                                            {Object.entries(specialcertificatelist).length > 0 && (
                                            <>
                                                {Object.entries(specialcertificatelist).map(([value, label]) => (
                                                <label key={value} className="sports-checkbox-item" style={{fontWeight:"normal"}}>
                                                    <input
                                                        type="checkbox"
                                                        name="field_special_certifications"
                                                        checked={formData.field_special_certifications?.includes(value)}  
                                                        value={value}
                                                        onChange={handleChange}
                                                    />
                                                    {label}
                                                </label>
                                                ))}
                                            </>
                                            )}
                                    </div>

                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-field-agent-region">Agent Region</label>
                                        <input
                                            type="text"
                                            id="edit-field-agent-region"
                                            name="field_agent_region"
                                            maxLength={100}
                                            value={formData.field_agent_region}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <fieldset className='admin-edit-profile-toggle'>
                                        <span style={{fontWeight: "bold"}}>
                                            <span className="">AGENT EXPIRATION DATE </span>
                                        </span>
                                        <div className="agent-expiry-date form-item">
                                            <div className="form-type-select" style={{width: "60px"}}>
                                                <label htmlFor="edit-field-agent-expiration-date-year">Year </label>
                                                {/* <select 
                                                    name="field_agent_expiration_date.year"
                                                    value={formData.field_agent_expiration_date?.year}
                                                    onChange={handleChange}
                                                > */}
                                                <select 
                                                    name="field_agent_expiration_year"
                                                    value={formData.field_agent_expiration_year}
                                                    onChange={handleChange}
                                                >
                                                    <option value=""></option>
                                                    {agentExpirationYears.map((y) => (
                                                        <option key={y.value} value={y.value}>
                                                        {y.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="form-type-select">
                                                <label htmlFor="edit-field-agent-expiration-date-month">Month </label>
                                                {/* <select 
                                                    name="field_agent_expiration_date.month"
                                                    value={formData.field_agent_expiration_date?.month}
                                                    onChange={handleChange}                    
                                                > */}
                                                <select 
                                                    name="field_agent_expiration_month"
                                                    value={formData.field_agent_expiration_month}
                                                    onChange={handleChange}
                                                >
                                                    <option value=""></option>
                                                    {months.map((m) => (
                                                        <option key={m.value} value={m.value}>
                                                        {m.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="form-type-select">
                                            <label htmlFor="edit-field-agent-expiration-date-day">Day </label>
                                            {/* <select  
                                                name="field_agent_expiration_date.day"
                                                value={formData.field_agent_expiration_date?.day}
                                                onChange={handleChange}                    
                                            > */}
                                            <select  
                                                name="field_agent_expiration_date"
                                                value={formData.field_agent_expiration_date}
                                                onChange={handleChange}                    
                                            >
                                                <option value=""></option>
                                                {days.map((d) => (
                                                    <option key={d.value} value={d.value}>
                                                    {d.label}
                                                    </option>
                                                ))}                
                                            </select>
                                            </div>
                                        </div>
                                    </fieldset>   

                                    <div className="form-item">
                                        <input
                                        type="checkbox"
                                        id="edit-field-agent-featured"
                                        name="field_agent_featured"
                                        value = "1" 
                                        defaultChecked={formData.field_agent_featured == "1" ? "true" : ""}                      
                                        onChange={handleChange}
                                        className="form-checkbox"
                                        />
                                        <label className="option" htmlFor="edit-field-agent-featured" style={{fontWeight:"normal"}}>Agent Featured </label>
                                    </div>     

                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-field-last-date-accept">Agent Last Date Of Accept</label>
                                        <input
                                            type="text"
                                            id="edit-field-last-date-accept"
                                            name="field_last_date_accept"
                                            maxLength={20}
                                            value={formData.field_last_date_accept}
                                            onChange={handleChange}
                                        />
                                    </div> 

                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-field-agent-slug">Agent Slug </label>
                                        <input 
                                            className="text-full form-text" 
                                            type="text" 
                                            id="edit-field-agent-slug" 
                                            name="field_agent_slug" 
                                            value={formData.field_agent_slug} 
                                            maxlength={100} 
                                            onChange={handleChange}
                                        />
                                    </div>               
                                </>
                            )}
                        </fieldset>

                        <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("scoutFields")} style={{color:"#0074bd", cursor:"pointer"}}>
                                <span style={{ fontSize: '10px',color:"#111" }}>{toggles.scoutFields ? '▼ ' : '▶ '}</span> 
                                <span className="toggle-titles">SCOUT</span>
                            </span>
                            {toggles.scoutFields && ( 
                                <>
                                    <div className="form-item">
                                        <label htmlFor='edit-field-scout-rank'>Scout Rank</label>
                                        <input
                                            type="text"
                                            id='edit-field-scout-rank'
                                            name="field_scout_rank"
                                            value={formData.field_scout_rank}
                                            onChange={handleChange}
                                            maxLength={10}
                                            size={12}
                                        />
                                    </div>     

                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-field-expiration-date">Scout Expiration Date </label>
                                        <input  
                                            type="text" 
                                            id="edit-field-expiration-date" 
                                            name="field_expiration_date" 
                                            value={formData.field_expiration_date}
                                            onChange={handleChange}
                                            maxlength={10} 
                                        />
                                    </div> 

                                    <div className="form-item">
                                        <input
                                            type="checkbox"
                                            id="edit-field-show-on-frontend-scout"
                                            name="field_show_on_frontend_scout"
                                            checked={formData.field_show_on_frontend_scout === 1}
                                            onChange={handleChange}
                                            className="form-checkbox"
                                        />
                                        <label className="option" htmlFor="edit-field-show-on-frontend-scout" style={{fontWeight:"normal"}}>
                                            Show on Frontend Scout
                                        </label>
                                    </div>

                                    <div className="form-item">
                                        <label htmlFor="edit-scout-sort-order">
                                            Scout Sort Order
                                        </label>
                                        <select
                                            id="edit-scout-sort-order"
                                            name="field_scout_sort_order"
                                            value={formData.field_scout_sort_order}
                                            onChange={handleChange}
                                        >
                                            <option value="">- None -</option>
                                            {Array.from({ length: 20}, (_, i) => {
                                                const sort = (i + 1).toString().padStart(1, '0');
                                                return <option key={sort} value={sort}>{sort}</option>;
                                            })}
                                        </select>
                                    </div>

                                    <div className="form-item">
                                        <label htmlFor="edit-field-scout-id">Scout ID #</label>
                                        <input 
                                            type="text" 
                                            id="edit-field-scout-id" 
                                            name="field_scoutid" 
                                            size={12} 
                                            maxLength={10}
                                            value={formData.field_scoutid}
                                            onChange={handleChange} 
                                        />
                                    </div>

                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-field-scout-title">Scout Title</label>
                                        <input  
                                            type="text" 
                                            id="edit-field-scout-title" 
                                            name="field_scout_title" 
                                            maxLength={100}
                                            value={formData.field_scout_title}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-scout-bio">Scout Biography</label>
                                        <div className="form-textarea-wrapper">
                                            <div>
                                                {editorMode.scoutBio ? (
                                                    <>
                                                        <Editor 
                                                            containerProps={{ style: { resize: 'vertical' } }} 
                                                            value={formData.field_scout_biography} 
                                                            onChange={e => onEditorChange('field_scout_biography', e.target.value)} 
                                                        />  
                                                    </>
                                                ) : (
                                                    <>
                                                        <textarea 
                                                            className="edit-scout-form-bio" 
                                                            id="edit-scout-biography" 
                                                            name="field_scout_biography"
                                                            value={formData.field_scout_biography} 
                                                            rows={5}
                                                            // onChange={(e) => setFormData((prev) => ({ ...prev, field_scout_biography: e.target.value })) }
                                                            onChange={e => onEditorChange('field_scout_biography', e.target.value)}
                                                        >
                                                        </textarea>
                                                        <div className="grippie" style={{
                                                            background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                                        }}>
                                                        </div>
                                                    </>
                                                )}
                                                <a onClick={() => toggleEditor('scoutBio')}>Switch to {editorMode.scoutBio ? 'Plain' : 'Rich'} Editor</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-item" style={{width:"100%"}}>
                                        <label htmlFor="edit-scout-photo-upload">Scout Photo</label>
                                        <div>
                                            {scoutImageError && (
                                                <div 
                                                    style={{ color: '#d9534f', 
                                                    border: '1px solid #d9534f',
                                                    backgroundColor: '#fef5f1', 
                                                    padding: '10px 10px 10px 50px', 
                                                    marginBottom: '10px',
                                                    width: '90%', 
                                                    borderRadius: '5px',
                                                    background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat` }}
                                                    dangerouslySetInnerHTML={{ __html: scoutImageError }}
                                                    >
                                                
                                                </div>
                                            )}
                                            {formData.field_scout_photo ? (
                                                <>
                                                <div>
                                                    <img
                                                        alt="Uploaded"
                                                        src={formData.field_scout_photo}
                                                        width="90" height="100"
                                                        style={{float: "left"}}
                                                    />
                                                    <div className="image-info" style={{float: "left", margin: "5px"}}>
                                                        <a
                                                            href={formData.field_scout_photo}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="image-name-link"
                                                        >
                                                        <img
                                                            src={getFileIcon(formData.field_scout_photo)}
                                                            alt="File Icon"
                                                            style={{ width: '16px', height: '16px', marginRight: '5px', verticalAlign: 'middle' }}
                                                        />
                                                        {formData.field_scout_photo.replace("/basic/web/pictures/", "")}
                                                        </a>
                            
                                                    </div>
                                                </div>

                                                <input
                                                type="button"
                                                value="Remove"
                                                className="form-submit"
                                                onClick={() => setFormData((prev) => ({ ...prev, field_delete_scout_photo:1,field_scout_photo:'' }))}
                                                />
                                                </>
                                            ) : selectedScoutImage ? (
                                                <>
                                                <div className="edit-scout-image-container">
                                                    <img
                                                        alt="Uploaded"
                                                        src={URL.createObjectURL(selectedScoutImage)}
                                                        style={{float: "left"}}
                                                        width="90" height="100"
                                                    />
                                                    <div className="image-info" style={{float: "left", margin: "5px"}}>
                                                        <a
                                                            href={URL.createObjectURL(selectedScoutImage)}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="image-name-link"
                                                        >
                                                            <img
                                                                src={getFileIcon(formData.field_scout_photo)}
                                                                alt="File Icon"
                                                                style={{ width: '16px', height: '16px', marginRight: '5px', verticalAlign: 'middle' }}
                                                            />
                                                            {selectedScoutImage.name}
                                                        </a>
                                                        <span className="image-size">
                                                            {' '}({(selectedScoutImage.size / 1024).toFixed(2)} KB)
                                                        </span>
                                                    </div>
                                                </div>
                                                <input
                                                    type="button"
                                                    value="Remove"
                                                    className="form-submit"
                                                    onClick={() => removeImage(setSelectedScoutImage, setScoutImageRemoved, setScoutImageError)}
                                                />
                                            </>
                                            ) : (
                                            <>
                                                <input
                                                    type="file"
                                                    id="edit-scout-photo-upload"
                                                    name="field_scout_photo"
                                                    accept="image/*"
                                                    onChange={(e) => 
                                                        handleUserRoleFileChange(e,setTempScoutImage, setScoutImageRemoved, setScoutImageError)}
                                                />
                                                <input
                                                    type="button"
                                                    value="Upload"
                                                    className="form-submit"
                                                    onClick={() => {
                                                        if (tempScoutImage) {
                                                            handleUserRoleImageUpload(
                                                                tempScoutImage,
                                                                setSelectedScoutImage,
                                                                setTempScoutImage
                                                            );
                                                        } else {
                                                            document.getElementById('edit-scout-photo-upload')?.click();
                                                        }
                                                    }}
                                                />
                                            </>
                                            )}
                                        </div>
                                        <div style={{clear: "both"}}></div>
                                        <div className="description">
                                            Image size must be a minimum of 100×100 px or a maximum of 1000×1000 px <br />
                                            Files must be less than <b>128 MB</b>.<br />
                                            Allowed file types: <b>png gif jpg jpeg</b>.
                                        </div>
                                    </div>
                    
                                    {/* Scout Contract */}
                                    <div className="edit-profile-row">
                                    <div>
                                        <fieldset>
                                        <legend>
                                            <span style={{fontWeight:"700"}}>Scout Contract</span>
                                        </legend>
                                        <div>
                                            {(scoutUploadedFiles?.length > 0 || scoutcontractuploadFiles?.length > 0) && (
                                            
                                            <table style={{fontSize:"14px", width:"90%"}}>
                                                <thead>
                                                <tr style={{textAlign:"left"}}>
                                                    <th>File information</th>
                                                    <th>Operations</th>
                                                </tr>
                                                </thead>
                                                <tbody style={{backgroundColor: "#eee"}}>
                                                {scoutUploadedFiles.length > 0 && scoutUploadedFiles.map((file, index) => (
                                                    <tr key={index} style={{borderBottom: "1px solid #ccc"}}>
                                                    <td>
                                                        <span>
                                                        <img
                                                            alt="File icon"
                                                            src={getFileIcon(file.name)}
                                                            style={{ marginRight: '8px' }}
                                                        />
                                                        <a href={URL.createObjectURL(file)} target="_blank" rel="noreferrer">
                                                            {file.name}
                                                        </a>
                                                        </span>
                                                        <span> ({(file.size / 1024).toFixed(2)} KB)</span>
                                                    </td>
                                                    <td>
                                                        <button
                                                        type="button"
                                                        className="form-submit"
                                                        onClick={() => removeFile(index, setScoutUploadedFiles)}
                                                        >
                                                        Remove
                                                        </button>
                                                    </td>
                                                    </tr>
                                                ))}
                                                {scoutcontractuploadFiles && scoutcontractuploadFiles.length > 0 && scoutcontractuploadFiles.map((file, index) => (
                                                <tr key={index} style={{borderBottom: "1px solid #ccc"}}>
                                                    <td>
                                                    <span className="file">
                                                        <img
                                                            className="file-icon"
                                                            alt="File icon"
                                                            src={getFileIcon(file.name)}
                                                            style={{ marginRight: '8px' }}
                                                        />
                                                        <a href={file.url} target="_blank" rel="noreferrer">
                                                        {file.name}
                                                        </a>
                                                    </span>
                                                    <span> ({(file.size / 1024).toFixed(2)} KB)</span>
                                                    </td>
                                                    <td>
                                                    <button
                                                        type="button"
                                                        className="form-submit"
                                                        onClick={() => removeScoutContractFile(index,file.fid)}
                                                    >
                                                        Remove
                                                    </button>
                                                    </td>
                                                </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                            )}
                                            {scoutErrorMessage && (
                                            <div 
                                                className="set-message-error" 
                                                style={{ 
                                                background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, 
                                                padding: "10px 10px 10px 50px",
                                                width: "90%",
                                                }}
                                            >
                                                {scoutErrorMessage}
                                            </div>
                                            )}
                                            <div className="form-item">
                                            <label htmlFor="edit-field-scout-contract">Add a new file</label>
                                            <div>
                                                <input
                                                type="file"
                                                id="edit-field-scout-contract"
                                                name="field_scout_contract"
                                                multiple
                                                onChange={(e) => handleFileInputChange(e, setScoutSelectedFiles, setScoutErrorMessage, setScoutFileInputKey)}
                                                key={scoutFileInputKey}
                                                style={{width: "auto"}}
                                                />
                                                <button type="button" onClick={() => handleUpload(scoutSelectedFiles, setScoutUploadedFiles, setScoutErrorMessage, setScoutSelectedFiles, setScoutFileInputKey)} disabled={scoutSelectedFiles.length === 0} className="form-submit">
                                                Upload
                                                </button>
                                            </div>
                                            <div className="description">
                                                Files must be less than <strong>128 MB</strong>.<br />
                                                Allowed file types: <strong>txt, png, jpg, jpeg, pdf, docx</strong>.
                                            </div>
                                            </div>
                                        </div>
                                        </fieldset>
                                    </div>
                                    </div> 

                                    {/* Scout Sport  */}
                                    <div className="form-item" style={{width: "50%"}}>
                                        <label htmlFor="edit-field-scout-sport">Scout Sport </label>    
                                        {scoutsportList.length > 0 && (
                                            <>
                                            {scoutsportList.map((scoutSportName) => (
                                                <label style={{fontWeight:"normal"}}>
                                                <input
                                                    type="checkbox"
                                                    name="field_scout_sport"
                                                    onChange={handleChange}
                                                    value={scoutSportName.key}
                                                    checked={formData.field_scout_sport?.includes(scoutSportName.key)}                                           
                                                    className="sport-list-input"
                                                />
                                                {scoutSportName.value}
                                                </label>
                                            ))}
                                            </>
                                        )}
                                    </div>

                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-field-scout-region">Scout Region</label>
                                        <input
                                            type="text"
                                            id="edit-field-scout-region"
                                            name="field_scout_region"
                                            maxLength={100}
                                            value={formData.field_scout_region}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-item">
                                        <input
                                        type="checkbox"
                                        id="edit-field-scout-featured"
                                        name="field_scout_featured"
                                        value = "1" 
                                        defaultChecked={formData.field_scout_featured == "1" ? "true" : ""}                      
                                        onChange={handleChange}
                                        className="form-checkbox"
                                        />
                                        <label className="option" htmlFor="edit-field-scout-featured" style={{fontWeight:"normal"}}>Scout Featured </label>
                                    </div> 

                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-field-scout-slug">Scout Slug </label>
                                        <input 
                                            className="text-full form-text" 
                                            type="text" 
                                            id="edit-field-scout-slug" 
                                            name="field_scout_slug" 
                                            value={formData.field_scout_slug} 
                                            maxlength="100" 
                                            onChange={handleChange}
                                        />
                                    </div>
                                </>
                            )}
                        </fieldset>

                        <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("mentorFields")} style={{color:"#0074bd", cursor:"pointer"}}>
                                <span style={{ fontSize: '10px',color:"#111" }}>{toggles.mentorFields ? '▼ ' : '▶ '}</span> 
                                <span className="toggle-titles">MENTOR</span>
                            </span>
                            {toggles.mentorFields && (
                                <>
                                    <div className="form-item">
                                        <label htmlFor="edit-mentor-sort-order">
                                            Mentor Sort Order
                                        </label>
                                        <select
                                            id="edit-mentor-sort-order"
                                            name="field_mentor_sort_order"
                                            value={formData.field_mentor_sort_order}
                                            onChange={handleChange}
                                        >
                                            <option value="">- None -</option>
                                            {Array.from({ length: 20}, (_, i) => {
                                                const sort = (i + 1).toString().padStart(1, '0');
                                                return <option key={sort} value={sort}>{sort}</option>;
                                            })}
                                        </select>
                                    </div>

                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-field-mentor-title">Mentor Title (Shown on the mentor's bio page)</label>
                                        <input 
                                            type="text" 
                                            id="edit-field-mentor-title" 
                                            onChange={handleChange} 
                                            name="field_mentor_title" 
                                            maxLength={100} 
                                            value={formData.field_mentor_title}
                                        />
                                    </div>

                                    {/* Mentor Biography */}          
                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-field-mentor-biography">Mentor Biography (Shown in the mentor's box on course pages)</label>              
                                        {editorMode.mentorbio ? (			  
                                            <Editor value={formData.field_mentor_biography} onChange={e => onEditorChange('field_mentor_biography', e.target.value)} />      
                                        ) : (
                                            <>	
                                                <textarea className="edit-agent-form-bio" value={formData.field_mentor_biography} onChange={e => onEditorChange('field_mentor_biography', e.target.value)} />
                                                <div
                                                    className="grippie" 
                                                    style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                                >
                                                </div>
                                            </>
                                        )}
                                        <a onClick={() => toggleEditor('mentorbio')}>Switch to {editorMode.mentorbio ? 'Plain' : 'Rich'} Editor</a>            
                                    </div>

                                    <div>
                                        <label htmlFor="edit-agent-photo-upload">Mentor Photo</label>
                                        <div>
                                            {mentorImageError && (
                                                <div 
                                                    style={{ color: '#d9534f', 
                                                    border: '1px solid #d9534f',
                                                    backgroundColor: '#fef5f1', 
                                                    padding: '10px 10px 10px 50px', 
                                                    marginBottom: '10px',
                                                    width: '90%', 
                                                    borderRadius: '5px',
                                                    background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat` }}
                                                    dangerouslySetInnerHTML={{ __html: mentorImageError }}
                                                    >
                                                
                                                </div>
                                            )}
                                            {formData.field_mentor_photo ? (
                                                <>
                                                    <div>
                                                        <img
                                                            alt="Uploaded"
                                                            src={formData.field_mentor_photo}
                                                            width="90" height="100"
                                                            style={{float: "left"}}
                                                        />
                                                        <div className="image-info" style={{float: "left", margin: "5px"}}>
                                                            <a
                                                                href={formData.field_mentor_photo}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="image-name-link"
                                                            >
                                                                <img
                                                                    src={getFileIcon(formData.field_mentor_photo)}
                                                                    alt="File Icon"
                                                                    style={{ width: '16px', height: '16px', marginRight: '5px', verticalAlign: 'middle' }}
                                                                />
                                                                {formData.field_mentor_photo.replace("/basic/web/pictures/", "")}
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <input
                                                        type="button"
                                                        value="Remove"
                                                        className="form-submit"
                                                        onClick={() => setFormData((prev) => ({ ...prev, field_delete_mentor_photo:1,field_mentor_photo:'' }))}
                                                    />
                                                </>
                                            ) : selectedMentorImage ? (
                                                <>
                                                    <div>
                                                        <img alt="Uploaded" src={URL.createObjectURL(selectedMentorImage)} style={{float: "left"}} width="90" height="100" />
                                                        <div className="image-info" style={{float: "left", margin: "5px"}}>
                                                            <a
                                                                href={URL.createObjectURL(selectedMentorImage)}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="image-name-link"
                                                            >
                                                                <img
                                                                    src={getFileIcon(formData.field_mentor_photo)}
                                                                    alt="File Icon"
                                                                    style={{ width: '16px', height: '16px', marginRight: '5px', verticalAlign: 'middle' }}
                                                                />
                                                                {selectedMentorImage.name}
                                                            </a>
                                                            <span className="image-size">
                                                                ({(selectedMentorImage.size / 1024).toFixed(2)} KB)
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <input
                                                        type="button"
                                                        value="Remove"
                                                        className="form-submit"
                                                        onClick={() => removeImage(setSelectedMentorImage, setMentorImageRemoved, setMentorImageError)}
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    <input
                                                        type="file"
                                                        id="edit-mentor-photo-upload"
                                                        name="field_mentor_photo"
                                                        accept="image/*"
                                                        onChange={(e) => 
                                                            handleUserRoleFileChange(e,setTempMentorImage, setMentorImageRemoved, setMentorImageError)}
                                                    />
                                                    <input
                                                        type="button"
                                                        value="Upload"
                                                        className="form-submit"
                                                        onClick={() => {
                                                            if (tempMentorImage) {
                                                                handleUserRoleImageUpload(
                                                                    tempMentorImage,
                                                                    setSelectedMentorImage,
                                                                    setTempMentorImage
                                                                );
                                                            } else {
                                                                document.getElementById('edit-mentor-photo-upload')?.click();
                                                            }
                                                        }}
                                                    />
                                                </>
                                            )}
                                        </div>
                                        <div style={{clear: "both"}}></div>
                                        <div className="description">
                                            Image size must be a minimum of 100*100 px or a maximum of 1000*1000 px<br />
                                            Files must be less than <b>128 MB</b>.<br />
                                            Allowed file types: <b>png gif jpg jpeg</b>.
                                        </div>
                                    </div>
                                    <div className="form-item" style={{width: "30%"}}>
                                        <label htmlFor="edit-field-mentor-sports">Mentor Sports</label>    
                                        {mentorSportsList.length > 0 && (
                                            <>
                                                {mentorSportsList.map((mentorSport) => (
                                                    <label key={mentorSport.value} style={{fontWeight:"normal"}}>
                                                    <input
                                                        type="checkbox"
                                                        name="field_mentor_sports"
                                                        value={mentorSport.value}
                                                        onChange={handleChange}                                                
                                                    />
                                                    {mentorSport.label}
                                                    </label>
                                                ))}
                                            </>
                                        )}
                                    </div>

                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-field-mentor-region">Mentor Region</label>
                                        <input
                                            type="text"
                                            id="edit-field-mentor-region"
                                            name="field_mentor_region"
                                            maxLength={100}
                                            value={formData.field_mentor_region}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    
                                    <fieldset className='admin-edit-profile-toggle'>
                                        <span style={{fontWeight: "bold"}}>PLACEMENTS</span>
                                        <div className="editprofile-fieldset-wrapper">
                                            <table style={{backgroundColor:"white"}}>
                                                <thead style={{fontSize: "14px"}}>
                                                <tr>
                                                    <th style={{ width: '50%' }}>Page</th>
                                                    <th style={{ width: '30%' }}>Sort Order</th>
                                                    <th>Delete</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    {formData.placements.map((placement, index) => (
                                                        <tr key={index}>
                                                        <td>
                                                            <select
                                                            name={`placement_page_${index}`}
                                                            value={placement.page}
                                                            onChange={(e) =>
                                                                handlePlacementChange(index, 'page', e.target.value)
                                                            }
                                                            style={{width:"100%"}}
                                                            >
                                                            <option value="">Select a page</option>
                                                                {pages.length > 0 && (
                                                                    <>
                                                                        {pages.map((item, index) => (
                                                                            <option key={item['id']} value={item['id']}>
                                                                                {item['title']}
                                                                            </option>
                                                                        ))}
                                                                    </>
                                                                )}
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <select
                                                            name={`placement_sort_order_${index}`}
                                                            className="adduser-form-select"
                                                            value={placement.order}
                                                            onChange={(e) =>
                                                                handlePlacementChange(index, 'order', e.target.value)
                                                            }
                                                            style={{width:"40px"}}
                                                            >
                                                            {[...Array(50)].map((_, i) => (
                                                                <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                                </option>
                                                            ))}
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <button
                                                            type="button"
                                                            className='quick-links-reg-button'
                                                            onClick={() => handleDeletePlacement(index)}
                                                            //disabled={formData.placements.length === 1}
                                                            >
                                                            Delete
                                                            </button>
                                                        </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            <a
                                                href="#"
                                                onClick={(e) => {
                                                e.preventDefault();
                                                handleAddPlacement();
                                                }}
                                            >
                                                +Add
                                            </a>
                                        </div>
                                    </fieldset>
                                </>     
                            )}
                        </fieldset>

                        <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("applicationFields")} style={{color:"#0074bd", cursor:"pointer"}}>
                                <span style={{ fontSize: '10px',color:"#111" }}>{toggles.applicationFields ? '▼ ' : '▶ '}</span> 
                                <span className="toggle-titles">APPLICATION</span>
                            </span>
                            {toggles.applicationFields && (
                                <>
                                    <div className="edit-profile-row" style={{marginTop: "15px"}}>
                                        <label>appID</label>
                                        <input
                                            className='edit-profile-password-box'
                                            type="text"
                                            name="field_appid"
                                            value={formData.field_appid}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="edit-profile-row">
                                        <label>Province/Region</label>
                                        <input
                                            type="text"
                                            name="field_province_region"
                                            value={formData.field_province_region}
                                            onChange={handleChange}
                                            maxLength={100}
                                        />
                                    </div>

                                    <div className="edit-profile-row">
                                        <label>How did you hear about us?</label>
                                        <input
                                            type='text'
                                            name="field_sports_recom"
                                            value={formData.field_sports_recom}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="edit-profile-row">
                                        <label>Referrer</label>
                                        <select
                                            name="field_referrer"
                                            value={formData.field_referrer}
                                            onChange={handleChange}
                                        >
                                            <option value="">- None -</option>
                                            <option value="Baseball America">Baseball America</option>
                                            <option value="DegreesinSports.com">DegreesinSports.com</option>
                                            <option value="Dr. Lashbrook gave me his business card!">Dr. Lashbrook gave me his business card!</option>
                                            <option value="ESPN">ESPN</option>
                                            <option value="Fox Sports Radio">Fox Sports Radio</option>
                                            <option value="Hockey News">Hockey News</option>
                                            <option value="My professor">My professor</option>
                                            <option value="NASSM">NASSM</option>
                                            <option value="NCAA News">NCAA News</option>
                                            <option value="Other">Other</option>
                                            <option value="Racingjunk.com">Racingjunk.com</option>
                                            <option value="Rah Rah Rugby">Rah Rah Rugby</option>
                                            <option value="Search Engine">Search Engine</option>
                                            <option value="Sherdog.com">Sherdog.com</option>
                                            <option value="SLAM magazine">SLAM magazine</option>
                                            <option value="SMWW Alumni told me about it">SMWW Alumni told me about it</option>
                                            <option value="SMWW Faculty">SMWW Faculty</option>
                                            <option value="WorkinSports.com">WorkinSports.com</option>
                                        </select>
                                    </div>

                                    <div className="edit-profile-row">
                                        <label>Name of person who referred you:</label>
                                        <input
                                            type="text"
                                            name="field_team_refer"
                                            value={formData.field_team_refer}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="edit-profile-row-multi-input">
                                        <label>Gender</label>
                                        <div className="edit-profile-radio-group">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="field_gender"
                                                    value="N/A"
                                                    checked={formData.field_gender === 'N/A'}
                                                    onChange={handleChange}
                                                /> N/A
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="field_gender"
                                                    value="Male"
                                                    checked={formData.field_gender === 'Male'}
                                                    onChange={handleChange}
                                                /> Male
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="field_gender"
                                                    value="Female"
                                                    checked={formData.field_gender === 'Female'}
                                                    onChange={handleChange}
                                                /> Female
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="field_gender"
                                                    value="Non-binary"
                                                    checked={formData.field_gender === 'Non-binary'}
                                                    onChange={handleChange}
                                                /> Non-binary
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="field_gender"
                                                    value="Prefer not to answer"
                                                    checked={formData.field_gender === 'Prefer not to answer'}
                                                    onChange={handleChange}
                                                /> Prefer not to answer
                                            </label>
                                        </div>
                                    </div>

                                    <div className="edit-profile-row form-item">
                                        <label>Education Level Completed</label>
                                        <input
                                            type="text"
                                            name="field_highest_grade"
                                            value={formData.field_highest_grade}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="edit-profile-row">
                                        <label>University</label>
                                        <input
                                            type="text"
                                            name="field_college"
                                            value={formData.field_college}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="edit-profile-row">
                                        <label>Major / Degree / Course Completed</label>
                                        <input
                                            type="text"
                                            name="field_degree"
                                            value={formData.field_degree}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="edit-profile-row">
                                        <label>Current Job</label>
                                        <input
                                            type="text"
                                            name="field_current_job" 
                                            value={formData.field_current_job}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="edit-profile-row">
                                        <label>Current Major</label>
                                        <input
                                            type="text"
                                            name="field_major"
                                            value={formData.field_major}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="edit-profile-row-multi-input">
                                        <label>Are You a Member of the Military?</label>
                                        <div className="edit-profile-radio-group">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="field_military"
                                                    value="N/A"
                                                    checked={formData.field_military === 'N/A'}
                                                    onChange={handleChange}
                                                /> N/A
                                                </label>
                                                <label>
                                                <input
                                                    type="radio"
                                                    name="field_military"
                                                    value="Yes"
                                                    checked={formData.field_military === 'Yes'}
                                                    onChange={handleChange}
                                                /> Yes
                                                </label>
                                                <label>
                                                <input
                                                    type="radio"
                                                    name="field_military"
                                                    value="No"
                                                    checked={formData.field_military === 'No'}
                                                    onChange={handleChange}
                                                /> No
                                                </label>
                                        </div>
                                    </div>

                                    <div className="edit-profile-row form-item" style={{width: "100%"}}>
                                        <label>If Yes, please provide your military ID number</label>
                                        <input
                                            type="text"
                                            name="field_military_id"
                                            value={formData.field_military_id}
                                            onChange={handleChange}
                                        />
                                    </div>
                        
                                    <div className="edit-profile-row-multi-input">
                                        <label>Have you ever been convicted of a felony?</label>
                                        <div className="edit-profile-radio-group">
                                            <label>
                                            <input
                                                type="radio"
                                                name="field_been_convicted"
                                                value="N/A"
                                                checked={formData.field_been_convicted === 'N/A'}
                                                onChange={handleChange}
                                            /> N/A
                                            </label>
                                            <label>
                                            <input
                                                type="radio"
                                                name="field_been_convicted"
                                                value="Yes"
                                                checked={formData.field_been_convicted === 'Yes'}
                                                onChange={handleChange}
                                            /> Yes
                                            </label>
                                            <label>
                                            <input
                                                type="radio"
                                                name="field_been_convicted"
                                                value="No"
                                                checked={formData.field_been_convicted === 'No'}
                                                onChange={handleChange}
                                            /> No
                                            </label>
                                        </div>
                                    </div>

                                    <div className="edit-profile-row form-item">
                                        <label>If yes, please explain</label>
                                        <input
                                            type='text'
                                            name="field_felony"
                                            value={formData.field_felony}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="edit-profile-row-multi-input">
                                        <label>Do you plan to take this course toward college credit?</label>
                                        <div className="edit-profile-radio-group">
                                            <label>
                                            <input
                                                type="radio"
                                                name="field_is_for_credit"
                                                value="N/A"
                                                checked={formData.field_is_for_credit === 'N/A'}
                                                onChange={handleChange}
                                            /> N/A
                                            </label>
                                            <label>
                                            <input
                                                type="radio"
                                                name="field_is_for_credit"
                                                value="Yes"
                                                checked={formData.field_is_for_credit === 'Yes'}
                                                onChange={handleChange}
                                            /> Yes
                                            </label>
                                            <label>
                                            <input
                                                type="radio"
                                                name="field_is_for_credit"
                                                value="No"
                                                checked={formData.field_is_for_credit === 'No'}
                                                onChange={handleChange}
                                            /> No
                                            </label>
                                        </div>
                                    </div>

                                    <div className="edit-profile-row form-item" style={{width:"100%"}}>
                                        <label>If you could work for your favorite sports team, who would it be?</label>
                                        <input
                                            type="text"
                                            name="field_favteam"
                                            value={formData.field_favteam}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="edit-profile-row">
                                        <label>Tell Us Your Story:</label>
                                        <textarea
                                            name="field_elaborate"
                                            value={formData.field_elaborate}
                                            onChange={handleChange}
                                        />
                                        <div className="grippie" style={{
                                            background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                        }}></div>
                                        <div className="description">
                                            To help us understand you as an individual and not just an applicant, please tell us about why you are interested in taking this course.
                                        </div>
                                    </div>

                                    <div className="edit-profile-row date-picker" style={{width: "100%", border:"1px solid #111",padding:"10px", margin: "1em 0"}}>
                                        <p style={{fontWeight:"bold", marginTop: "0px"}}>DATE OF APP</p>
                                        <label htmlFor="date_of_app">Date</label>
                                        <DatePicker
                                            selected={formData.field_date_of_app}
                                            onChange={(date) => setFormData({ ...formData, field_date_of_app: date })}
                                            dateFormat="yyyy-MM-dd"
                                            // placeholderText={currentFormattedDate}
                                            id="date_of_app"
                                            name="field_date_of_app"
                                        />
                                        <span className='edit-profile-desc'>Eg., {currentFormattedDate}</span>
                                    </div>

                                    <div className="edit-profile-row date-picker" style={{width: "100%", border:"1px solid #111",padding:"10px", margin: "1em 0"}}>
                                        <p style={{fontWeight:"bold", marginTop: "0px"}}>DATE OF ACCEPTANCE</p>
                                        <label htmlFor="date_of_acceptance">Date</label>
                                            <DatePicker
                                            selected={formData.field_date_of_acceptance}
                                            onChange={(date) => setFormData({ ...formData, field_date_of_acceptance: date })}
                                            dateFormat="yyyy-MM-dd"
                                        // placeholderText={currentFormattedDate}
                                            id="date_of_acceptance"
                                            name="field_date_of_acceptance"
                                        />
                                        <span className='edit-profile-desc'>Eg., {currentFormattedDate}</span>
                                    </div>

                                    <div className="edit-profile-row applied-courses" style={{paddingLeft: "10px"}}>
                                        <div className="applied-courses-label" onClick={() => handleToggle("appliedCoursesList")}>
                                            <span style={{ fontSize: '10px',color:"#111" }}>{toggles.appliedCoursesList ? '▼ ' : '▶ '}</span>
                                            <label style={{display: "inline"}}>Applied Courses</label>
                                        </div>
                                        {toggles.appliedCoursesList && (
                                            <div className="applied-courses-list">
                                                {courseList.length > 0 && ( 
                                                    <>
                                                        {courseList.map(({ id, course_code, course_name }) => (
                                                            <label key={id} className="checkbox-item">
                                                                <input
                                                                    type="checkbox"
                                                                    name="applied_courses"
                                                                    value={course_code}
                                                                    checked={formData.applied_courses.includes(course_code)}
                                                                    onChange={handleChange}
                                                                    className='applied-courses-list-input'
                                                                />
                                                                {course_name}
                                                            </label>
                                                        ))}
                                                    </>
                                                )}
                                            </div>
                                        )}
                                    </div>  

                                    <div className="edit-profile-row ">
                                        <label htmlFor="edit-field-app-status">App Status</label>
                                        <select
                                            id="edit-field-app-status"
                                            name="field_app_status"
                                            className="form-select"
                                            value={formData.field_app_status}
                                            onChange={handleChange}
                                        >
                                            <option value="_none">- None -</option>
                                            <option value="1">Denied</option>
                                            <option value="2">Pending</option>
                                            <option value="3">Approved need payment</option>
                                            <option value="4">Approved and paid</option>
                                            <option value="5">Approved and fee waived</option>
                                            <option value="6">Approved and paid in partial</option>
                                            <option value="7">Didn't take class</option>
                                            <option value="8">Job app</option>
                                            <option value="9">More info request</option>
                                            <option value="10">Talk to Lynn</option>
                                            <option value="11">India Meet and Greet</option>
                                        </select>
                                    </div> 

                                    <div className="edit-profile-row">
                                        <label>High School</label>
                                        <input
                                            type="text"
                                            name="field_high_school"
                                            value={formData.field_high_school}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="edit-profile-row">
                                        <label>High School Location</label>
                                        <input
                                            type="text"
                                            name="field_hs_location"
                                            value={formData.field_hs_location}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="edit-profile-row">
                                        <label>High School Graduation Year</label>
                                        <input
                                            type="text"
                                            name="field_hs_grad_year"
                                            value={formData.field_hs_grad_year}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="edit-profile-row">
                                        <label>College Graduation Date</label>
                                        <input
                                            type="text"
                                            name="field_college_grad_date"
                                            value={formData.field_college_grad_date}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    
                                    <div className="edit-profile-common-checkbox">
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="sales-call-made"
                                                name="field_sales_call_made"
                                                value = "1" 
                                                defaultChecked={formData.field_sales_call_made == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option" htmlFor="sales-call-made">Sales Call Made</label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="field_app_is_agent"
                                                name="field_app_is_agent"
                                                value = "1" 
                                                defaultChecked={formData.field_app_is_agent == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option" htmlFor="field_app_is_agent">App is Agent</label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="app_is_scout"
                                                name="field_app_is_scout"
                                                value = "1" 
                                                defaultChecked={formData.field_app_is_scout == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option" htmlFor="app_is_scout">App is Scout</label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="over18"
                                                name="field_over18"
                                                value = "1" 
                                                defaultChecked={formData.field_over18 == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option" htmlFor="over18">Over 18</label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="dormant"
                                                name="field_dormant"
                                                value = "1" 
                                                defaultChecked={formData.field_dormant == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option" htmlFor="dormant">Dormant</label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="srm400"
                                                name="field_srm400"
                                                value = "1" 
                                                defaultChecked={formData.field_srm400 == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option" htmlFor="srm400">SRM400</label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="am400"
                                                name="field_am400"
                                                value = "1" 
                                                defaultChecked={formData.field_am400 == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option" htmlFor="am400">AM 400</label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="gi_bill"
                                                name="field_gi_bill"
                                                value = "1" 
                                                defaultChecked={formData.field_gi_bill == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option" htmlFor="gi_bill">GI Bill</label>
                                        </div>
                                    </div>

                                    <div className="edit-profile-row form-item">
                                        <label htmlFor="edit-field-gi-bill-status">GI Bill Status</label>
                                        <select
                                            id="edit-field-gi-bill-status"
                                            name="field_gi_bill_status"
                                            className="form-select"
                                            value={formData.field_gi_bill_status}
                                            onChange={handleChange}
                                        >
                                            <option value="_none">- None -</option>
                                            <option value="1">Eligible for GI Bill</option>
                                            <option value="2">Filled out Veteran's ID with WOU</option>
                                            <option value="3">Has Registration form</option>
                                            <option value="4">Faxed Completed Registration form to SMWW</option>
                                            <option value="5">GI Bill Completed</option>
                                        </select>
                                    </div>

                                    <div className="edit-profile-row date-picker" style={{width: "100%", border:"1px solid #111",padding:"10px", margin: "1em 0"}}>
                                        <p style={{fontWeight:"bold", marginTop: "0px"}}>BIRTHDAY</p>
                                        <label>Date</label>
                                        <DatePicker name="field_birthday"
                                        selected={formData.field_birthday}
                                        onChange={handleDateChange}
                                        />
                                        <span className='edit-profile-desc'>E.g., {currentFormattedBDate}</span>
                                    </div>

                                    <div className="form-type-checkbox form-item" style={{width: "100%"}}>
                                        <input
                                            type="checkbox"
                                            id="edit-field-new-apply"
                                            name="field_new_apply"
                                            value = "1" 
                                            defaultChecked={formData.field_new_apply == "1" ? "true" : ""}
                                            onChange={handleChange}
                                            className="form-checkbox"
                                        />
                                        <label className="option" htmlFor="edit-field-new-apply" style={{fontWeight: "normal"}}>
                                            New Apply
                                        </label>
                                        <div className="description">
                                            Used when new application submit, even it's a exists account, use this field when divvy.
                                        </div>
                                    </div>

                                    <div className="edit-profile-row">
                                        <label>How did you hear about the DOC Talk?</label>
                                        <select
                                            name="field_hear_about_doc_talk"
                                            value={formData.field_hear_about_doc_talk}
                                            onChange={handleChange}
                                        >
                                            <option value="">- None -</option>
                                            <option value="Facebook">Facebook</option>
                                            <option value="Family/Friend Referral">Family/Friend Referral</option>
                                            <option value="Instagram">Instagram</option>
                                            <option value="LinkedIn">LinkedIn</option>
                                            <option value="SMWW Mentor">SMWW Mentor</option>
                                            <option value="SMWW Newsletter">SMWW Newsletter</option>
                                            <option value="SMWW Website">SMWW Website</option>
                                            <option value="Twitter">Twitter</option>
                                        </select>
                                    </div>
                                </>
                            )}
                        </fieldset>
                        <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("athleteFields")} style={{color:"#0074bd", cursor:"pointer"}}>
                                <span style={{ fontSize: '10px',color:"#111" }}>{toggles.athleteFields ? '▼ ' : '▶ '}</span> 
                                <span className="toggle-titles">ATHLETE</span>
                            </span>
                            {toggles.athleteFields && (
                                <>
                                    <div className="edit-profile-common-checkbox" style={{marginTop: "15px"}}>
                                        <div className="form-type-checkbox">
                                            <input
                                            type="checkbox"
                                            id="show-on-frontend-athlete"
                                            name="field_show_on_frontend_athlete"
                                            value = "1" 
                                            defaultChecked={formData.field_show_on_frontend_athlete == "1" ? "true" : ""}                      
                                            onChange={handleChange}
                                            className="form-checkbox"
                                            />
                                            <label className="option" htmlFor="show-on-frontend-athlete">Show On Frontend Athlete </label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                            type="checkbox"
                                            id="field-current-class"
                                            name="field_current_class"
                                            value = "1" 
                                            defaultChecked={formData.field_current_class == "1" ? "true" : ""}
                                            onChange={handleChange}
                                            className="form-checkbox"
                                            />
                                            <label className="option" htmlFor="field-current-class">Current Class </label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                            type="checkbox"
                                            id="athlete-featured"
                                            name="field_athlete_featured"
                                            value = "1" 
                                            defaultChecked={formData.field_athlete_featured == "1" ? "true" : ""}
                                            onChange={handleChange}
                                            className="form-checkbox"
                                            />
                                            <label className="option" htmlFor="athlete-featured">Athlete Featured </label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                            type="checkbox"
                                            id="available"
                                            name="field_available"
                                            value = "1" 
                                            defaultChecked={formData.field_available == "1" ? "true" : ""}
                                            onChange={handleChange}
                                            className="form-checkbox"
                                            />
                                            <label className="option" htmlFor="available">Available </label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                            type="checkbox"
                                            id="smww-basketball"
                                            name="field_show_on_smww_basketball"
                                            value = "1" 
                                            defaultChecked={formData.field_show_on_smww_basketball == "1" ? "true" : ""}
                                            onChange={handleChange}
                                            className="form-checkbox"
                                            />
                                            <label className="option" htmlFor="smww-basketball">Show on SMWW Basketball </label>
                                        </div>
                                    </div>
                                    <div>
                                        <fieldset className='admin-edit-profile-toggle'>
                                            <span>
                                                <span style={{fontWeight: "bold"}}>DATE OF SIGNING</span>
                                            </span>
                                            <div className="call-back-container">
                                                <div className="form-item" style={{width: "160px"}}>
                                                    <label htmlFor="date_of_signing_date">Date</label>
                                                    <DatePicker
                                                        name="field_date_of_signing.date"
                                                        selected={formData.field_date_of_signing?.date}
                                                        onChange={(date) =>
                                                            setFormData({
                                                            ...formData,
                                                            field_date_of_signing: {
                                                                ...formData.field_date_of_signing,
                                                                date: date,
                                                            },
                                                            })
                                                        }
                                                        dateFormat="yyyy-MM-dd"
                                                        //placeholderText={currentFormattedDate}
                                                        id="date_of_signing"
                                                    />
                                                    <span className='edit-profile-desc'>Eg., {currentFormattedDate}</span>
                                                </div>
                                                <div className="form-item" style={{width: "160px"}}>
                                                    <label htmlFor="date_of_signing_time">Time </label>
                                                    <div className="call-back-field">
                                                        <TimeInput
                                                            name="field_date_of_signing.time"
                                                            value={formData.field_date_of_signing?.time}
                                                            onChange={handleChange}
                                                            //placeholder={initialTime}
                                                        />
                                                        <span className='edit-profile-desc'>Eg., {initialTime}</span>
                                                    </div>
                                                </div>              
                                            </div>
                                        </fieldset>
                                    </div>
                                    <div className="form-item">
                                        <label>Signing Agent ID</label>
                                        <input
                                            type="text"
                                            name="field_signing_agent_id"
                                            value={formData.field_signing_agent_id}
                                            onChange={handleChange}
                                            maxLength={10}
                                            size={12}
                                        />
                                    </div>
                                    <div className="form-item">
                                        <label>Current Agent ID</label>
                                        <input
                                            type="text"
                                            name="field_current_agent_id"
                                            value={formData.field_current_agent_id}
                                            onChange={handleChange}
                                            maxLength={10}
                                            size={12}
                                        />
                                    </div>
                                    <div>
                                        <fieldset className='admin-edit-profile-toggle'>
                                            <span>
                                                <span style={{fontWeight: "bold"}}>DATE OF ASSIGNMENT</span>
                                            </span>
                                            <div className="call-back-container">
                                                <div className="form-item" style={{width: "160px"}}>
                                                    <label htmlFor="date_of_assign_date">Date</label>
                                                    <DatePicker
                                                        name="field_date_of_assignment.date"
                                                        selected={formData.field_date_of_assignment?.date}
                                                        onChange={(date) =>
                                                            setFormData({
                                                            ...formData,
                                                            field_date_of_assignment: {
                                                                ...formData.field_date_of_assignment,
                                                                date: date,
                                                            },
                                                            })
                                                        }
                                                        dateFormat="yyyy-MM-dd"
                                                        //placeholderText={currentFormattedDate}
                                                        id="date_of_assign"
                                                    />
                                                    <span className='edit-profile-desc'>Eg., {currentFormattedDate}</span>
                                                </div>
                                                <div className="form-item" style={{width: "160px"}}>
                                                    <label htmlFor="date_of_assign_time">Time </label>
                                                    <div className="call-back-field">
                                                        <TimeInput
                                                            name="field_date_of_assignment.time"
                                                            value={formData.field_date_of_assignment?.time}
                                                            onChange={handleChange}
                                                            //placeholder={initialTime}
                                                        />
                                                        <span className='edit-profile-desc'>Eg., {initialTime}</span>
                                                    </div>
                                                </div>              
                                            </div>
                                        </fieldset>
                                    </div>
                                    <div className="form-item">
                                        <label htmlFor="edit-field-athlete-sport">Athlete Sport</label>    
                                        <select 
                                            id="edit-field-athlete-sport" 
                                            name="field_athlete_sports" 
                                            value={formData.field_athlete_sports}
                                            onChange={handleAthleteSportChange}
                                            multiple
                                            className=""
                                        >
                                            <option value="_none">- None -</option>
                                            {Object.entries(athletesportList).map(([value, label]) => (
                                                <option key={value} value={value}>{label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="edit-profile-row">
                                        <label>Athlete Position</label>
                                        <textarea
                                            name="field_athlete_position"
                                            value={formData.field_athlete_position}
                                            onChange={handleChange}
                                        />
                                        <div className="grippie" style={{
                                            background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                        }}></div>
                                    </div>
                                <div>
                                    <fieldset className='admin-edit-profile-toggle'>
                                        <span>
                                            <span style={{fontWeight: "bold"}}>DOB </span>
                                        </span>
                                        <div className="call-back-container">
                                            <div className="form-item" style={{width: "160px"}}>
                                                <label htmlFor="date_of_birth">Date</label>
                                                <DatePicker
                                                    name="field_dob.date"
                                                    selected={formData.field_dob?.date}
                                                    onChange={(date) =>
                                                        setFormData({
                                                        ...formData,
                                                        field_dob: {
                                                            ...formData.field_dob,
                                                            date: date,
                                                        },
                                                        })
                                                    }
                                                    dateFormat="yyyy-MM-dd"
                                                    //placeholderText={currentFormattedDate}
                                                    id="date_of_birth"
                                                />
                                                <span className='edit-profile-desc'>Eg., {currentFormattedDate}</span>
                                            </div>
                                            <div className="form-item" style={{width: "160px"}}>
                                                <label htmlFor="edit-field-call-back-day">Time </label>
                                                <div className="call-back-field">
                                                    {/* DOB → HH:MM */}
                                                    <TimeInput
                                                        name="field_dob.time"
                                                        value={formData.field_dob?.time}
                                                        onChange={handleChange}
                                                        //placeholder={initialDobTime}   // HH:MM
                                                        format="HH:mm"                 // only if TimeInput supports this prop
                                                    />
                                                    <span className='edit-profile-desc'>Eg., {initialDobTime}</span>
                                                </div>
                                            </div>              
                                        </div>
                                    </fieldset>
                                </div>
                                <div className="form-item">
                                    <label>Athlete Rank</label>
                                    <input
                                        type="text"
                                        name="field_athlete_rank"
                                        value={formData.field_athlete_rank}
                                        onChange={handleChange}
                                        maxLength={10}
                                        size={12}
                                    />
                                </div>
                                <div className="form-item">
                                    <label>Tier Status</label>
                                    <input
                                        type="text"
                                        name="field_tier_status"
                                        value={formData.field_tier_status}
                                        onChange={handleChange}
                                        maxLength={10}
                                        size={12}
                                    />
                                </div>
                                <div>
                                    <fieldset className='admin-edit-profile-toggle'>
                                        <span>
                                            <span style={{fontWeight: "bold"}}>TIER STATUS DATE </span>
                                        </span>
                                        <div className="call-back-container">
                                            <div className="form-item" style={{width: "160px"}}>
                                                <label htmlFor="date_of_tier_status">Date</label>
                                                <DatePicker
                                                    name="field_tier_status_date.date"
                                                    selected={formData.field_tier_status_date?.date}
                                                    onChange={(date) =>
                                                        setFormData({
                                                        ...formData,
                                                        field_tier_status_date: {
                                                            ...formData.field_tier_status_date,
                                                            date: date,
                                                        },
                                                        })
                                                    }
                                                    dateFormat="yyyy-MM-dd"
                                                   // placeholderText={currentFormattedDate}
                                                    id="date_of_tier_status"
                                                />
                                                <span className='edit-profile-desc'>Eg., {currentFormattedDate}</span>
                                            </div>
                                            <div className="form-item" style={{width: "160px"}}>
                                                <label htmlFor="edit-field-call-back-day">Time </label>
                                                <div className="call-back-field">
                                                    <TimeInput
                                                        name="field_tier_status_date.time"
                                                        value={formData.field_tier_status_date?.time}
                                                        onChange={handleChange}
                                                       // placeholder={initialTime}
                                                    />
                                                    <span className='edit-profile-desc'>Eg., {initialTime}</span>
                                                </div>
                                            </div>              
                                        </div>
                                    </fieldset>
                                </div>
                                <div className="form-item">
                                    <label htmlFor="edit-field-athlete-type">Athlete Type</label>
                                    <select 
                                        className="" 
                                        id="edit-field-athlete-type" 
                                        name="field_athlete_type"
                                        value={formData.field_athlete_type}
                                        onChange={handleChange}
                                    >
                                        <option value="_none">- None -</option>
                                        {Object.entries(athleteType).map(([value, label]) => (
                                            <option key={value} value={value}>
                                                {label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="edit-profile-row">
                                    <label for="edit-field-athlete-height">Athlete height </label>
                                    <input class="text-full form-text" type="text" id="edit-field-athlete-height" name="field_athlete_height" value={formData.field_athlete_height} size="60" maxlength="255" onChange={handleChange}/>
                                </div>
                                <div className="edit-profile-row-multi-input">
                                    <label>Height unit </label>
                                    <div className="edit-profile-radio-group">
                                        <label>
                                            <input
                                                type="radio"
                                                name="field_height_unit"
                                                value="_none"
                                                checked={formData.field_height_unit === '_none'}
                                                onChange={handleChange}
                                            /> 
                                            N/A
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="field_height_unit"
                                                value="Imperial"
                                                checked={formData.field_height_unit === 'Imperial'}
                                                onChange={handleChange}
                                            />   
                                            Imperial
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="field_height_unit"
                                                value="Metric"
                                                checked={formData.field_height_unit === 'Metric'}
                                                onChange={handleChange}
                                            /> 
                                            Metric
                                        </label>
                                    </div>
                                </div>
                                <div className="edit-profile-row" style={{marginTop: "1em"}}>
                                    <label for="edit-field-athlete-weight">Athlete weight </label>
                                    <input class="text-full form-text" type="text" id="edit-field-athlete-weight" name="field_athlete_weight" value={formData.field_athlete_weight} size="60" maxlength="255" onChange={handleChange}/>
                                </div>
                                <div className="edit-profile-row-multi-input">
                                    <label>Weight unit </label>
                                    <div className="edit-profile-radio-group">
                                        <label>
                                            <input
                                                type="radio"
                                                name="field_weight_unit"
                                                value="_none"
                                                checked={formData.field_weight_unit === '_none'}
                                                onChange={handleChange}
                                            /> 
                                            N/A
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="field_weight_unit"
                                                value="lb"
                                                checked={formData.field_weight_unit=== 'lb'}
                                                onChange={handleChange}
                                            />   
                                            lb
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="field_weight_unit"
                                                value="kg"
                                                checked={formData.field_weight_unit === 'kg'}
                                                onChange={handleChange}
                                            /> 
                                            kg
                                        </label>
                                    </div>
                                </div>
                                </>
                            )}
                        </fieldset>
                        <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("eventAttendee")} style={{color:"#0074bd", cursor:"pointer"}}>
                                <span style={{ fontSize: '10px',color:"#111" }}>{toggles.eventAttendee ? '▼ ' : '▶ '}</span> 
                                <span className="toggle-titles">EVENT ATTENDEE</span>
                            </span>
                            {toggles.eventAttendee && (
                                <>
                                    <div className="edit-profile-row" style={{marginTop: "15px"}}>
                                        <label htmlFor="edit-field-first-name-badge">Please enter your first name as you would like it to be displayed on your conference name badge </label>
                                        <input
                                            type="text" 
                                            id="edit-field-first-name-badge" 
                                            name="field_first_name_badge" 
                                            value={formData.field_first_name_badge}
                                            onChange={handleChange}
                                            maxlength={50} 
                                        />
                                    </div>

                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-field-last-name-badge">Please enter your last name as you would like it to be displayed on your conference name badge </label>
                                        <input
                                            type="text" 
                                            id="edit-field-last-name-badge" 
                                            name="field_last_name_badge" 
                                            value={formData.field_last_name_badge}
                                            onChange={handleChange}
                                            maxlength={50} 
                                        />
                                    </div>

                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-field-name-school-badge">Please enter your school or university as you would like it to be displayed on your conference name badge </label>
                                        <input
                                            type="text" 
                                            id="edit-field-name-school-badge" 
                                            name="field_name_school_badge" 
                                            value={formData.field_name_school_badge}
                                            onChange={handleChange}
                                            maxlength={100} 
                                        />
                                        </div>

                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-field-name-title-badge">Please enter your title as you would like it to be displayed on your conference name badge </label>
                                        <input
                                            type="text" 
                                            id="edit-field-name-title-badge" 
                                            name="field_name_title_badge" 
                                            value={formData.field_name_title_badge}
                                            onChange={handleChange}
                                            maxlength={100} 
                                        />
                                    </div>

                                    <div className="edit-profile-row">
                                        <label htmlFor="edit-field-name-org-badge">Please enter your team or league as you would like it to be displayed on your conference name badge </label>
                                        <input
                                            type="text" 
                                            id="edit-field-name-org-badge" 
                                            name="field_name_org_badge" 
                                            value={formData.field_name_org_badge}
                                            onChange={handleChange}
                                            maxlength={100} 
                                        />
                                    </div>

                                    <div style={{marginBottom: "1em"}}>
                                        <label for="edit-field-amount-paid">Amount Paid </label>
                                        <input type="text" id="edit-field-amount-paid" name="field_amount_paid" value={formData.field_amount_paid} size="14" maxlength="12" className="form-text" onChange={handleChange}/>
                                    </div>

                                    <div className="edit-profile-row">
                                        <label for="edit-field-contact-id">Contact ID </label>
                                        <input className="text-full form-text" type="text" id="edit-field-contact-id" name="field_contact_id" value={formData.field_contact_id} size="60" maxlength="10" onChange={handleChange}/>
                                        <div className="description">Event attendee contact id in old system.</div>
                                    </div>

                                    <div className="edit-profile-row">
                                        <label for="edit-field-event-id">Event ID </label>
                                        <input className="text-full form-text" type="text" id="edit-field-event-id" name="field_event_id" value={formData.field_event_id} size="60" maxlength="10" onChange={handleChange}/>
                                        <div className="description">Event attendee - event id in old system.</div>
                                    </div>

                                    <div className="edit-profile-row">
                                        <label for="edit-field-coupon-code">Coupon Code </label>
                                        <input className="text-full form-text" type="text" id="edit-field-coupon-code" name="field_coupon_code" value={formData.field_coupon_code} size="60" maxlength="30" onChange={handleChange}/>
                                        <div className="description">Event attendee - coupon code in old system.</div>
                                    </div>

                                    <div className="edit-profile-row">
                                        <label>Contact Notes</label>
                                        <textarea
                                            name="field_contact_notes"
                                            value={formData.field_contact_notes}
                                            onChange={handleChange}
                                        />
                                        <div className="grippie" 
                                            style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                        >   
                                        </div>
                                        <div className='description'>    
                                            Event attendee - notes
                                        </div>
                                    </div>
                                </>
                            )}
                        </fieldset>
                        <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("leadFields")} style={{color:"#0074bd", cursor:"pointer"}}>
                                <span style={{ fontSize: '10px',color:"#111" }}>{toggles.leadFields ? '▼ ' : '▶ '}</span> 
                                <span className="toggle-titles">LEAD</span>
                            </span>
                            {toggles.leadFields && (
                                <>
                                    <div className="form-item">
                                        <label htmlFor="edit-field-lead-type">Lead Type</label>    
                                        {/* {leadList.length > 0 && (
                                            <>
                                                {leadList.map((leadType) => (
                                                    <label key={leadType.value} style={{fontWeight:"normal"}}>
                                                    <input
                                                        type="checkbox"
                                                        name="field_lead_type"
                                                        value={leadType.value}
                                                        // onChange={handleChange}
                                                        onChange={(e) => {
                                                            handleChange(e);

                                                            // Debug logs
                                                            console.log("Clicked Lead Type:", leadType.value);
                                                            console.log("Checked:", e.target.checked);
                                                            console.log("Updated formData.field_lead_type:", formData.field_lead_type);
                                                        }}
                                                        
                                                    />
                                                    {leadType.label}
                                                    </label>
                                                ))}
                                            </>
                                        )} */}
                                          {Object.entries(leadList).map(([value, label]) => (
  <label key={value} style={{ fontWeight: 'normal' }}>
    <input
      type="checkbox"
      name="field_lead_type"
      value={value}
      checked={formData.field_lead_type?.includes(value)}
      onChange={(e) => handleChange(e)}
    />
    {label}
  </label>
))} 
                                    </div>

                                    <div className="form-item" style={{width:"100%"}}>
                                        <fieldset className='admin-edit-profile-toggle'>
                                            <div>
                                            <span style={{fontWeight: "bold"}}>CALL BACK </span>
                                            </div>
                                            <div className="call-back-container">
                                            <div className="form-item">
                                                <label htmlFor="edit-field-call-back-month">Month </label>
                                                <div className="call-back-field">
                                                <select 
                                                    className="" 
                                                    id="edit-field-call-back-month" 
                                                    name="field_call_back_month"
                                                    value={formData.field_call_back_month}
                                                    onChange={handleChange}
                                                >
                                                    <option value=""></option>
                                                    {months.map((m) => (
                                                        <option key={m.value} value={m.value}>
                                                        {m.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                </div>
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-call-back-day">Day </label>
                                                <div className="call-back-field">
                                                <select 
                                                    className="" 
                                                    id="edit-field-call-back-day" 
                                                    name="field_call_back_day"
                                                    value={formData.field_call_back_day}
                                                    onChange={handleChange}
                                                >
                                                    <option value=""></option>
                                                    {days.map((d) => (
                                                    <option key={d.value} value={d.value}>
                                                        {d.label}
                                                    </option>
                                                    ))}  
                                                </select>
                                                </div>
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-call-back-year">Year </label>
                                                <div className="call-back-field">
                                                <select 
                                                    className="" 
                                                    id="edit-field-call-back-year" 
                                                    name="field_call_back_year"
                                                    value={formData.field_call_back_year}
                                                    onChange={handleChange}
                                                >
                                                    <option value=""></option>
                                                    {years.map((y) => (
                                                    <option key={y.value} value={y.value}>
                                                    {y.label}
                                                    </option>
                                                    ))}
                                                </select>
                                                </div>
                                            </div>
                                            <div className="form-item" style={{marginLeft:".75em"}}>
                                                <label htmlFor="edit-field-call-back-hour">Hour </label>
                                                <div className="call-back-field">
                                                <select 
                                                    className="" 
                                                    id="edit-field-call-back-hour" 
                                                    name="field_call_back_hour"
                                                    value={formData.field_call_back_hour}
                                                    onChange={handleChange}
                                                >
                                                    <option value=""></option>
                                                    {hours.map((h) => (
                                                    <option key={h.value} value={h.value}>
                                                    {h.label}
                                                    </option>
                                                    ))}
                                                </select>
                                                </div>
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-call-back-minute">Minute </label>
                                                <div className="call-back-field">
                                                <select 
                                                    className="" 
                                                    id="edit-field-call-back-minute" 
                                                    name="field_call_back_minute"
                                                    value={formData.field_call_back_minute}
                                                    onChange={handleChange}
                                                >
                                                    <option value=""></option>
                                                    {clock.map((m) => (
                                                    <option key={m} value={m}>
                                                        {m}
                                                    </option>
                                                    ))}
                                                </select>
                                                </div>
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-call-back-second">Second </label>
                                                <div className="call-back-field">
                                                <select 
                                                    className="" 
                                                    id="edit-field-call-back-second" 
                                                    name="field_call_back_second"
                                                    value={formData.field_call_back_second}
                                                    onChange={handleChange}
                                                >
                                                    <option value=""></option>
                                                    {clock.map((s) => (
                                                    <option key={s} value={s}>
                                                        {s}
                                                    </option>
                                                    ))}                              
                                                </select>
                                                </div>
                                            </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                    <div style={{clear:"both"}}></div>

                                    <div className="form-item">
                                        <label htmlFor="edit-field-lead-sort-flag">Lead Sort Flag </label>
                                        <select 
                                        id="edit-field-lead-sort-flag" 
                                        name="field_lead_sort_flag" 
                                        style={{marginLeft: "0px"}}
                                        value={formData.field_lead_sort_flag}
                                        onChange={handleChange}
                                        >
                                        <option value="_none">- None -</option>
                                        <option value="1">College Credit</option>
                                        <option value="2">G.I. Bill</option>
                                        <option value="3">NOVA</option>
                                        </select>
                                    </div>

                                    <div className="form-item">
                                        <label htmlFor="edit-field-lead-priority">Lead Priority </label>
                                        <select 
                                            id="edit-field-lead-priority" 
                                            name="field_lead_priority" 
                                            value={formData.field_lead_priority}
                                            onChange={handleChange}
                                        >
                                            <option value="_none">- None -</option>
                                            <option value="Hot">Hot</option>
                                            <option value="Medium">Medium</option>
                                            <option value="Cold">Cold</option>
                                        </select>
                                    </div>
                                </>
                            )}
                        </fieldset>

                        <div className="edit-profile-row">
                            <label htmlFor="agency_scout_email">Agency-scout Email</label>
                            <input 
                                className="" 
                                type="text" 
                                id="agency_scout_email" 
                                name="field_smww_email" 
                                value={formData.field_smww_email} 
                                onChange={handleChange}  
                            /> 
                        </div>

                        <div className="edit-profile-row">
                            <label htmlFor="edit-field-realemail">Real Email </label>
                            <input 
                                className="" 
                                type="text" 
                                id="edit-field-realemail" 
                                name="field_realemail" 
                                value={formData.field_realemail}
                                onChange={handleChange}
                                maxlength={50}
                            />
                        </div>

                        <div className="edit-profile-row">
                            <label>Street Address</label>
                            <input
                                type="text"
                                name="field_street"
                                value={formData.field_street}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="edit-profile-row">
                            <label>Address (cont.)</label>
                            <input
                                type="text"
                                name="field_street_2"
                                value={formData.field_street_2}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="edit-profile-row">
                            <label>City/Town</label>
                            <input
                                type="text"
                                name="field_city"
                                value={formData.field_city}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="edit-profile-row">
                            <label>State/Province</label>
                            <select
                                name="field_state"
                                value={formData.field_state}
                                onChange={handleChange}
                            >
                                <option value="">Select State</option>
                                {Object.keys(statelist).map(state => {
                                        return <option key={statelist[state].name} value={statelist[state].name}>{statelist[state].name}</option>;
                                        })}
                                {/* Add state options */}
                            </select>
                        </div>

                        <div className="edit-profile-row">
                            <label>Zip/Postal Code</label>
                            <input
                                type="text"
                                name="field_postal_code"
                                value={formData.field_postal_code}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="edit-profile-row">
                            <label>Country</label>
                            <select name="field_country" value={formData.field_country} onChange={handleChange}>
                                <option value="">Select Country</option>
                                {Object.keys(countrieslist).map(item => {
                                return <option key={countrieslist[item].label} value={countrieslist[item].label}>{countrieslist[item].label}</option>
                                })}
                            </select>
                        </div>

                        {(
                            userRoles.includes(configData.ROLE_AGENT) ||
                            userRoles.includes(configData.ROLE_SCOUT) ||
                            userRoles.includes(configData.ROLE_GLOBAL_AMBASSADOR)
                        ) && (
                            <div className="edit-profile-row">
                                <label htmlFor="field_continentid">
                                    Continent 
                                    <span className="form-required" title="This field is required.">*</span>
                                </label>
                                <select
                                    id="field_continentid"
                                    name="field_continentid"                             
                                    value={formData.field_continentid}
                                    onChange={handleChange}                            
                                >
                                    <option value="4">Asia</option>
                                    <option value="5">Africa</option>
                                    <option value="7">North America</option>
                                    <option value="2">South America</option>
                                    <option value="3">Europe</option>
                                    <option value="6">Australia/Oceania</option>
                                </select>
                            </div>
                        )}

                        <div className="edit-profile-row">
                            <label htmlFor="edit-field-other-referrer">Referrer Other </label>
                            <input 
                                className="" 
                                type="text" 
                                id="edit-field-other-referrer" 
                                name="field_other_referrer" 
                                value={formData.field_other_referrer}
                                onChange={handleChange}
                                maxlength={120} 
                            />
                        </div>

                        <div className="edit-profile-row">
                            <label>LinkedIn URL</label>
                            <textarea
                                name="field_linkedin_url"
                                value={formData.field_linkedin_url}
                                onChange={handleChange}
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div>
                        </div>

                        <div className="edit-profile-row">
                            <label>Primary Phone</label>
                            <input
                                type="text"
                                name="field_phone"
                                value={formData.field_phone}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-item">
                            <label htmlFor="edit-field-age">Age </label>
                            <input 
                                type="text" 
                                id="edit-field-age" 
                                name="field_age" 
                                value={formData.field_age}
                                onChange={handleChange} 
                                size={12} 
                                maxlength={10} 
                            />
                        </div>

                        <div className="edit-profile-row">
                            <label>Secondary Phone</label>
                            <input
                                type="text"
                                name="field_secondary_phone"
                                value={formData.field_secondary_phone}
                                onChange={handleChange}
                            />
                        </div> 

                        <div className="edit-profile-row">
                            <label htmlFor="edit-field-night-phone">Night Phone </label>
                            <input 
                                className="" 
                                type="text" 
                                id="edit-field-night-phone" 
                                name="field_night_phone" 
                                value={formData.field_night_phone}
                                onChange={handleChange}
                                maxlength={100} 
                            />
                        </div>

                        <div className="edit-profile-row">
                            <label for="edit-field-fax">Fax </label>
                                <input 
                            className="form-text" 
                            type="text" 
                            id="edit-field-fax" 
                            name="field_fax" 
                            value={formData.field_fax} 
                            onChange={handleChange} 
                            maxlength="30"/>
                        </div>

                        <div className="edit-profile-row">
                            <label for="edit-field-pager">Pager </label>
                            <input 
                                className="form-text" 
                                type="text" 
                                id="edit-field-pager" 
                                name="field_pager" 
                                value={formData.field_pager} 
                                onChange={handleChange} 
                                maxlength="100"
                            />
                        </div>

                        <div className='edit-profile-row'>
                            <label>User Assignment </label>
                            
                            <select
                                name="field_user_assignment"
                                value={formData.field_user_assignment}
                                onChange={handleChange}
                            >
                                <option value=""></option>
                                {salespersonList.length > 0 && (
                                <>
                                    {salespersonList.map((item, index) => {
                                        return <>
                                        {item['uid'] != null && (
                                            <><option value={item['uid']}>{item['name']}</option></>
                                        )}
                                    </>
                                    })}  
                                </>
                                )}
                                
                            </select>
                        </div>

                        <div className="edit-profile-row">
                            <label htmlFor="edit-field-education-state">State </label>
                            <input 
                                className="" 
                                type="text" 
                                id="edit-field-education-state" 
                                name="field_education_state" 
                                value={formData.field_education_state}
                                onChange={handleChange} 
                                maxlength={50} 
                            />
                        </div>

                        <div className="edit-profile-row">
                            <label htmlFor="edit-field-education-city">City </label>
                            <input 
                                className="" 
                                type="text" 
                                id="edit-field-education-city" 
                                name="field_education_city" 
                                value={formData.field_education_city}
                                onChange={handleChange}
                                maxlength={50} 
                            />
                        </div>

                        <div className="edit-profile-row">
                            <label htmlFor="edit-field-school">School </label>
                            <input 
                                className="" 
                                type="text" 
                                id="edit-field-school" 
                                name="field_school" 
                                value={formData.field_school}
                                onChange={handleChange}
                                maxlength={50}
                            />
                        </div>

                        <div className="form-item">
                            <label htmlFor="edit-field-last-attended">Last Attended Education </label>
                            <select 
                                id="edit-field-last-attended" 
                                name="field_last_attended" 
                                value={formData.field_last_attended}
                                onChange={handleChange}
                                className=""
                            >
                            <option value="_none">- None -</option>
                            {schoolYears.map((y) => (
                                <option key={y.value} value={y.value}>
                                {y.label}
                                </option>
                            ))}
                            </select>
                        </div>

                        <div className="form-item">
                            <label for="edit-field-athelte-id">Athlete ID # </label>
                            <input type="text" id="edit-field-athelte-id" name="field_athelte_id" value={formData.field_athelte_id} size="12" maxlength="10" className="form-text" onChange={handleChange}/>
                        </div>
                    
                        <div className="edit-profile-row">
                            <label for="edit-field-nationality">Nationality </label>
                            <input className="text-full form-text" type="text" id="edit-field-nationality" name="field_nationality" value={formData.field_nationality} size="60" maxlength="255" onChange={handleChange}/>
                        </div>

                        <div className="edit-profile-row">
                            <label htmlFor="reg_step">App Register Step</label>
                                <select
                                id="appRegister_step"
                                name="field_reg_step"
                                className="adduser-register-select"
                                value={formData.field_reg_step}
                                onChange={handleChange}
                                >
                                <option value="_none">- None -</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                            </select>
                        </div>

                        <div className="form-item" style={{width:"70%"}}>
                            <label htmlFor="edit-field-cuc-degrees-und">Applied Degrees</label>
                            <div id="edit-field-cuc-degrees" className="form-checkboxes">
                                {/* {degreesList.map(({ value, label }) => (
                                    <div
                                    key={value} 
                                    // className={`form-item form-type-checkbox form-item-field-cuc-degrees-${value}`}          
                                    >
                                        <label
                                        // className="option"
                                        style={{fontWeight:"normal"}}
                                        htmlFor={`edit-field-cuc-degrees-${value.toLowerCase()}`}
                                    >
                                        <input
                                    type="checkbox"
                                    id={`edit-field-cuc-degrees-${value.toLowerCase()}`}
                                    name="field_cuc_degrees"
                                    value={value}
                                    checked={(formData.field_cuc_degrees || []).includes(value)}
                                    onChange={handleChange}
                                    className="form-checkbox"
                                    />
                                
                                        {label}
                                    </label>
                                    </div>
                                ))} */}
                                {Object.entries(degreesList).map(([value, label]) => (
                          
                                    <div key={value}>
                                        <label
                                            style={{fontWeight:"normal"}}
                                            htmlFor={`edit-field-cuc-degrees-${value.toLowerCase()}`}
                                        >
                                            <input
                                                type="checkbox"
                                                id={`edit-field-cuc-degrees-${value.toLowerCase()}`}
                                                name="field_cuc_degrees"
                                                value={value}
                                                checked={(formData.field_cuc_degrees || []).includes(value)}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            {label}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                            
                        <div className="edit-profile-row">
                            <label for="edit-field-ip-address">IP Address </label>
                            <input class="text-full form-text" type="text" id="edit-field-ip-address" name="field_ip_address" value={formData.field_ip_address} size="60" maxlength="255"  onChange={handleChange}/>
                        </div>

                        <div className="edit-profile-row">
                            <label>Instagram URL</label>
                            <input
                                type="text"
                                name="field_instagram_url"
                                value={formData.field_instagram_url}
                                onChange={handleChange}      
                            />
                        </div>

                        {/* TikTok */}
                        <div className="edit-profile-row">
                            <label>TikTok URL</label>
                            <input
                                type="text"
                                name="field_tiktok_url"
                                value={formData.field_tiktok_url}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Twitter */}
                        <div className="edit-profile-row">
                            <label>Twitter URL</label>
                            <input
                                type="text"
                                name="field_twitter_url"
                                value={formData.field_twitter_url}
                                onChange={handleChange}
                            />
                        </div>

                        {/* YouTube */}
                        <div className="edit-profile-row">
                            <label>YouTube URL</label>
                            <input
                                type="text"
                                name="field_user_youtube_url"
                                value={formData.field_user_youtube_url}
                                onChange={handleChange}
                            />
                        </div>
                        
                        {/* Facebook */}
                        <div className="edit-profile-row">
                            <label>Facebook URL</label>
                            <input
                                type="text"
                                name="field_facebook_url"
                                value={formData.field_facebook_url}
                                onChange={handleChange}     
                            />
                        </div>

                        <div className="edit-profile-row">
                            <label>Instagram Handle</label>
                            <input
                                type="text"
                                name="field_instagram_handle"
                                value={formData.field_instagram_handle}
                                onChange={handleChange}      
                            />
                        </div>

                        {/* LinkedIn */}
                        <div className="edit-profile-row">
                            <label>LinkedIn Handle</label>
                            <input
                                type="text"
                                name="field_linkedin_handle"
                                value={formData.field_linkedin_handle}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="edit-profile-row">
                            <label>Facebook Handle</label>
                            <input
                                type="text"
                                name="field_facebook_handle"
                                value={formData.field_facebook_handle}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="edit-profile-row">
                            <label>Degree Application </label>
                            <textarea
                                name="field_cuc_application"
                                value={formData.field_cuc_application}
                                onChange={handleChange}
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div>                    
                        </div>

                        <div className="edit-profile-row">
                            <label>Talk With Dr. Lashbrook </label>
                            <textarea
                                name="field_talk_with_dr_lashbrook"
                                value={formData.field_talk_with_dr_lashbrook}
                                onChange={handleChange}
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div>                    
                        </div>

                        <div className="edit-profile-row">
                            <label>Advanced Certificates Question </label>
                            <textarea
                                name="field_advanced_certificates_ques"
                                value={formData.field_advanced_certificates_ques}
                                onChange={handleChange}
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div>                    
                        </div>

                        <div className="edit-profile-row">
                            <label>Request More Info </label>
                            <textarea
                                name="field_request_more_info"
                                value={formData.field_request_more_info}
                                onChange={handleChange}
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div>            
                        </div>

                        <div className="edit-profile-row">
                            <label for="edit-field-most-recent-college">Most recent college </label>
                            <input class="text-full form-text" type="text" id="edit-field-most-recent-college" name="field_most_recent_college" value={formData.field_most_recent_college} size="60" maxlength="255" onChange={handleChange}/>
                        </div>

                        <div className="edit-profile-row">
                            <label>Most recent seasons stats </label>
                            {editorMode.most_recent_seasons_stats ? (
                                <Editor value={formData.field_most_recent_seasons_stats} onChange={e => onEditorChange('field_most_recent_seasons_stats', e.target.value)} />  
                            ) : (
                                <>	
                                    <textarea className="edit-agent-form-bio" value={formData.field_most_recent_seasons_stats} onChange={e => onEditorChange('field_most_recent_seasons_stats', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                </>
                            )}  
                            <a onClick={() => toggleEditor('most_recent_seasons_stats')}>Switch to {editorMode.most_recent_seasons_stats ? 'Plain' : 'Rich'} Editor</a>          
                        </div>

                        <div className="edit-profile-row">
                            <label>First Form Submitted </label>
                            <textarea
                                name="field_first_form_submission"
                                value={formData.field_first_form_submission}
                                onChange={handleChange}
                            />
                            <div className="grippie" 
                                style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                            >   
                            </div>             
                        </div>
                        
                        <div className="edit-profile-row">
                            <label for="edit-field-most-recent-college">Last Form Submitted </label>
                            <input className="text-full form-text" type="text" id="edit-field-last-form-submitted" name="field_last_form_submitted" value={formData.field_last_form_submitted} size="60" maxlength="600" onChange={handleChange}/>
                        </div>

                        {/* How to Contact */}          
                        <div className="edit-profile-row">
                            <label>How to Contact</label>
                            {editorMode.contact ? (
                                <Editor value={formData.field_how_to_contact_client} onChange={e => onEditorChange('field_how_to_contact_client', e.target.value)} /> 
                            ) : (
                                <>	
                                    <textarea className="edit-agent-form-bio" value={formData.field_how_to_contact_client} onChange={e => onEditorChange('field_how_to_contact_client', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                </>
                            )}   
                            <a onClick={() => toggleEditor('contact')}>Switch to {editorMode.contact ? 'Plain' : 'Rich'} Editor</a>
                        </div>

                        <div className="form-item">
                            <label>Agents Represented By </label>
                            <select multiple value={formData.field_agents_represented_by} onChange={handleAgentRepresentChange}>
                                {/* {AgentReprsentedBy.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))} */}
                                {agentlist.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                        </div>

                        <div className="edit-profile-row">
                            <label>Instagram Followers</label>
                            <input
                                type="text"
                                name="field_instagram_followers"
                                value={formData.field_instagram_followers}
                                onChange={handleChange}     
                            />
                        </div>        
                
                        <div className="edit-profile-row">
                            <label>Facebook Followers</label>
                            <input
                                type="text"
                                name="field_facebook_followers"
                                value={formData.field_facebook_followers}
                                onChange={handleChange}
                            />
                        </div>
                    
                        <div className="edit-profile-row">
                            <label>Twitter Followers</label>
                            <input
                                type="text"
                                name="field_twitter_followers"
                                value={formData.field_twitter_followers}
                                onChange={handleChange}
                            />
                        </div>
                
                        <div className="edit-profile-row">
                            <label>YouTube Subscribers</label>
                            <input
                                type="text"
                                name="field_youtube_subscribers"
                                value={formData.field_youtube_subscribers}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="edit-profile-row">
                            <label>LinkedIn Followers</label>
                            <input
                                type="text"
                                name="field_linkedin_followers"
                                value={formData.field_linkedin_followers}
                                onChange={handleChange}
                            />
                        </div>
                
                        <div className="edit-profile-row">
                            <label>TikTok Followers</label>
                            <input
                                type="text"
                                name="field_tiktok_followers"
                                value={formData.field_tiktok_followers}
                                onChange={handleChange}
                            />
                        </div>
            
                        <div className="form-item" style={{width: "100%"}}>
                            <label>Which sport(s) do you want to work in the most? </label>
                            <select multiple value={formData.field_sports_you_worked} onChange={handleSportsyouWorkedChange}>
                                {/* {SportsyouWorked.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))} */}
                                {Object.entries(SportsyouWorked).map(([value, label]) => (
                                    <option key={value} value={value}>
                                        {label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className='edit-profile-row'>
                            <label htmlFor="edit-field-other-sports-you-worked">Other Sports you worked </label>
                            <input className="text-full form-text" type="text" id="edit-field-other-sports-you-worked" name="field_other_sports_you_worked" value={formData.field_other_sports_you_worked} maxlength="255" onChange={handleChange}/>
                        </div>

                        <div className="form-item" style={{width: "100%"}}>
                            <label>Which job role would best describe your dream job?</label>
                            <select multiple value={formData.field_your_dream_job} onChange={handleDreamJobChange}>
                                {Object.entries(dreamJob).map(([value, label]) => (
                                    <option key={value} value={value}>
                                        {label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className='edit-profile-row'>
                            <label htmlFor="edit-field-other-dream-job">Other dream job</label>
                            <input className="text-full form-text" type="text" id="edit-field-other-dream-job" name="field_other_dream_job" value={formData.field_other_dream_job} maxlength="255" onChange={handleChange}/>
                        </div>

                        <div className="edit-profile-row">
                            <label>Job Resume </label>
                            <textarea
                                name="field_job_resume"
                                value={formData.field_job_resume}
                                onChange={handleChange}
                            />
                            <div className="grippie" 
                                style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                            >   
                            </div>             
                        </div>

                        {/* Athlete Contract */}
                        <div className="edit-profile-row">
                        <div>
                            <fieldset>
                            <legend>
                                <span style={{fontWeight:"700"}}>Athlete Contract</span>
                            </legend>
                            <div>
                                {(athleteUploadedFiles?.length > 0 || athletecontractuploadFiles?.length > 0) && (
                                <table style={{fontSize:"14px", width:"90%"}}>
                                    <thead>
                                    <tr style={{textAlign:"left"}}>
                                        <th>File information</th>
                                        <th>Operations</th>
                                    </tr>
                                    </thead>
                                    <tbody style={{backgroundColor: "#eee"}}>
                                    
                                    {athleteUploadedFiles.length > 0 &&  athleteUploadedFiles.map((file, index) => (
                                        <tr key={index} style={{borderBottom: "1px solid #ccc"}}>
                                        <td>
                                            <span>
                                            <img
                                                alt="File icon"
                                                src={getFileIcon(file.name)}
                                                style={{ marginRight: '8px' }}
                                            />
                                            <a href={URL.createObjectURL(file)} target="_blank" rel="noreferrer">
                                                {file.name}
                                            </a>
                                            </span>
                                            <span> ({(file.size / 1024).toFixed(2)} KB)</span>
                                        </td>
                                        <td>
                                            <button
                                            type="button"
                                            className="form-submit"
                                            onClick={() => removeFile(index, setAthleteUploadedFiles)}
                                            >
                                            Remove
                                            </button>
                                        </td>
                                        </tr>
                                    ))}
                                    {athletecontractuploadFiles && athletecontractuploadFiles.length > 0 && athletecontractuploadFiles.map((file, index) => (
                                        <tr key={index} style={{borderBottom: "1px solid #ccc"}}>
                                        <td>
                                            <span>
                                            <img
                                                alt="File icon"
                                                src={getFileIcon(file.name)}
                                                style={{ marginRight: '8px' }}
                                            />
                                            <a href={file.url} target="_blank" rel="noreferrer">
                                                {file.name}
                                            </a>
                                            </span>
                                            <span> ({(file.size / 1024).toFixed(2)} KB)</span>
                                        </td>
                                        <td>
                                            <button
                                            type="button"
                                            className="form-submit"
                                            onClick={() => removeAthleteContractFile(index,file.fid)}
                                            
                                            >
                                            Remove
                                            </button>
                                        </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                                )}

                                
                                {athleteErrorMessage && (
                                <div 
                                    className="set-message-error" 
                                    style={{ 
                                    background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, 
                                    padding: "10px 10px 10px 50px",
                                    width: "90%",
                                    }}
                                >
                                    {athleteErrorMessage}
                                </div>
                                )}
                                <div className="form-item">
                                <label htmlFor="edit-field-athlete-contract">Add a new file</label>
                                <div>
                                    <input
                                    type="file"
                                    id="edit-field-athlete-contract"
                                    name="field_athlete_contract"
                                    multiple
                                    onChange={(e) => handleFileInputChange(e, setAthleteSelectedFiles, setAthleteErrorMessage, setAthleteFileInputKey)}
                                    key={athleteFileInputKey}
                                    style={{width: "auto"}}
                                    />
                                    <button type="button" onClick={() => handleUpload(athleteSelectedFiles, setAthleteUploadedFiles, setAthleteErrorMessage, setAthleteSelectedFiles, setAthleteFileInputKey)} disabled={athleteSelectedFiles.length === 0} className="form-submit">
                                    Upload
                                    </button>
                                </div>
                                <div className="description">
                                    Files must be less than <strong>128 MB</strong>.<br />
                                    Allowed file types: <strong>txt, png, jpg, jpeg, pdf, docx</strong>.
                                </div>
                                </div>
                                        </div>
                                    </fieldset>
                                    </div>
                                </div>

                        {/* Sports Focus */}
                        <div className="form-item">
                            <label>Sports Focus</label>
                            <select multiple value={formData.field_sports_focus} onChange={handleSportsFocusChange}>
                                {Object.entries(sportsfocus).map(([value, label]) => (
                                    <option key={value} value={value}>
                                        {label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Q&A */}         
                        <div className="edit-profile-row">
                            <label>Q&A</label>
                            {editorMode.qa ? (
                                <Editor value={formData.field_q_a} onChange={e => onEditorChange('field_q_a', e.target.value)} />  
                            ) : (
                                <>	
                                    <textarea className="edit-agent-form-bio" value={formData.field_q_a} onChange={e => onEditorChange('field_q_a', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                </>
                            )}       
                            <a onClick={() => toggleEditor('qa')}>Switch to {editorMode.qa ? 'Plain' : 'Rich'} Editor</a>       
                        </div>

                        <div className="field-show-on-frontend-ambassador" id="edit-field-show-on-frontend-ambassado">
                            <div className="form-item">
                                <input
                                    type="checkbox"
                                    id="edit-field-show-on-frontend-ambassado-und"
                                    name="field_show_on_frontend_ambassado"
                                    // defaultChecked={formData.field_show_on_frontend_ambassado === "1" ? "true":"false"}
                                    onChange={handleChange}
                                    className="form-checkbox"
                                />
                                <label className="option" htmlFor="edit-field-show-on-frontend-ambassado-und" style={{fontWeight: "normal"}}>
                                    Show on Frontend Global Ambassador
                                </label>
                            </div>
                        </div>

                        <div className='edit-profile-row'>
                            <label htmlFor="edit-field-ambassador-slug">Ambassador Slug</label>
                            <input className="" type="text" id="edit-field-ambassador-slug" name="field_ambassador_slug" value={formData.field_ambassador_slug} maxlength="255" onChange={handleChange}/>
                        </div>

                        <div className="edit-profile-row date-picker" style={{border:"1px solid #111",padding:"10px", margin: "1em 0", width: "100%"}}>
                            <p style={{fontWeight:"bold",marginTop: "0px"}}>RECENT GRADUATION DATE </p>
                            <label htmlFor="recent-graduation-date">Date</label>
                                <DatePicker
                                selected={formData.field_recent_graduation_date}
                                onChange={(date) => setFormData({ ...formData, field_recent_graduation_date: date })}
                                dateFormat="yyyy-MM-dd"
                                // placeholderText={currentFormattedDate}
                                id="recent-graduation-date"
                                name="field_recent_graduation_date"
                            
                            />
                            <span className='edit-profile-desc'>Eg., {currentFormattedDate}</span>
                        </div>

                        <div className="edit-profile-row">
                            <label>Graduated Courses </label>
                            <textarea
                                name="field_graduated_courses"
                                value={formData.field_graduated_courses}
                                onChange={handleChange}
                            />
                            <div className="grippie" 
                                style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                            >   
                            </div>           
                        </div>

                        <div className="edit-profile-row">
                            <label>Video Highlights </label>
                            {editorMode.video_highlights ? (
                                <Editor value={formData.field_video_highlights} onChange={e => onEditorChange('field_video_highlights', e.target.value)} />   
                            ) : (
                                <>	
                                    <textarea className="edit-agent-form-bio" value={formData.field_video_highlights} onChange={e => onEditorChange('field_video_highlights', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                </>
                            )}    
                            <a onClick={() => toggleEditor('video_highlights')}>Switch to {editorMode.video_highlights ? 'Plain' : 'Rich'} Editor</a>          
                        </div>

                        <div className="edit-profile-row">
                            <label>Google Click ID </label>
                            <textarea
                                name="field_google_click_id"
                                value={formData.field_google_click_id}
                                onChange={handleChange}
                            />
                            <div className="grippie" 
                                style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                            >   
                            </div>           
                        </div>

                        <div className="field-tellme-with-news&offers" id="edit-field-tellme-with-news&offers">
                            <div className="form-item">
                                <input
                                type="checkbox"
                                id="edit-field-tellme-with-news&offers"
                                name="field_text_me_with_news_offers"
                                // defaultChecked={formData.field_text_me_with_news_offers === "1" ? "true":"false"}
                                onChange={handleChange}
                                className="form-checkbox"
                                />
                                <label className="option" htmlFor="edit-field-tellme-with-news&offers" style={{fontWeight: "normal"}}>
                                Text me with news and offers 
                                </label>
                            </div>
                        </div>
                        </>
                    <div className="edit-profile-buttons">
                        <span><button className='edit-profile-submit-button' type="submit">{formData.button_name}</button></span>
                        <span><button className='cancel-button' type="submit" onClick={handleCancel} >{formData.cancel_button}</button></span>
                    </div>
                </form>
            ) : (
                <><p>You are not authorized</p></>   
            )}
        </div>
        )}
        </>
    );
    };

    export default AdminEditProfile;